import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../module_mechanics/Styles/FormList.css";
import {
    faEdit, faTrash, faSave, faSearch, faRefresh, faSpinner, faEye, faTimesCircle, faDollarSign, faBalanceScale, faCalculator,
    faExclamationTriangle, faCheckCircle, faTimes, faChevronLeft,
    faChevronRight, faFilePdf, faCalendar, faUser, faStore, faPhone,faExclamationCircle,
    faEnvelope, faMapMarkerAlt, faTag, faExchangeAlt, faChevronDown,
    faExpand, faCompress, faArrowsAlt, faMinus, faPlus, faFilter, faEyeSlash,
    faTruck, faBuilding, faGlobe, faUserTag, faStickyNote, faExternalLinkAlt,
    faBoxes, faBox, faCubes, faBoxOpen, faLayerGroup, faIndustry, faHashtag, faBarcode,
    faCreditCard, faPalette, faRulerCombined, faWarehouse, faCubes as faCubesIcon, faTag as faTagIcon
} from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// ============================================
// SHARED TRANSLATOR
// ============================================
const createSharedTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) { }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) { }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Products List': 'مصنوعات کی فہرست',
                'All products details are below': 'تمام مصنوعات کی تفصیلات نیچے ہیں',
                'Product Name': 'مصنوعات کا نام',
                'Product Code': 'مصنوعات کا کوڈ',
                'Batch Number': 'بیچ نمبر',
                'Barcode': 'بارکوڈ',
                'Category': 'زمرہ',
                'Company': 'کمپنی',
                'Supplier': 'سپلائر',
                'Packing Type': 'پیکنگ کی قسم',
                'Sub Packing Type': 'ذیلی پیکنگ کی قسم',
                'Items Per Pack': 'فی پیک اشیاء',
                'Unit': 'یونٹ',
                'Retail Price': 'فروخت قیمت',
                'Total Quantity': 'کل مقدار',
                'Quantity Alert': 'کم اسٹاک الرٹ',
                'Expiry Date': 'میعاد ختم ہونے کی تاریخ',
                'Actions': 'اعمال',
                'Added By': 'شامل کرنے والا',
                'Search products...': 'مصنوعات تلاش کریں...',
                'Refresh': 'ریفریش کریں',
                'Export PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Edit': 'ترمیم کریں',
                'Delete': 'حذف کریں',
                'Close': 'بند کریں',
                'Save Changes': 'تبدیلیاں محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'Previous': 'پچھلا',
                'Next': 'اگلا',
                'All': 'سب',
                'Product Details': 'مصنوعات کی تفصیلات',
                'Switch Shop': 'شاپ تبدیل کریں',
                'No shop selected': 'کوئی شاپ منتخب نہیں',
                'Please select a shop to view products': 'براہ کرم مصنوعات دیکھنے کے لیے شاپ منتخب کریں',
                'S.No': 'نمبر',
                'Products': 'مصنوعات',
                'Shop': 'شاپ',
                'View': 'دیکھیں',
                'Update Product': 'مصنوعات اپڈیٹ کریں',
                'Updating...': 'اپڈیٹ ہو رہا ہے...',
                'Product updated successfully': 'مصنوعات کامیابی سے اپڈیٹ ہو گئی',
                'Error updating product': 'مصنوعات اپڈیٹ کرنے میں خرابی',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'Yes, Delete': 'ہاں، حذف کریں',
                'No, Cancel': 'نہیں، منسوخ کریں',
                'Portrait': 'عمودی',
                'Landscape': 'افقی',
                'A4': 'A4',
                'Letter': 'لیٹر',
                'Legal': 'لیگل',
                'A5': 'A5',
                'Product Report': 'مصنوعات کی رپورٹ',
                'Product Directory': 'مصنوعات کی ڈائریکٹری',
                'Total Products': 'کل مصنوعات',
                'Generated': 'تیار کردہ',
                'Report ID': 'رپورٹ آئی ڈی',
                'Generated by': 'تیار کردہ بذریعہ',
                'Shop Code': 'شاپ کوڈ',
                'FILTERS APPLIED': 'فلٹرز لاگو ہیں',
                'Search': 'تلاش کریں',
                'From': 'سے',
                'To': 'تک',
                'Page': 'صفحہ',
                'Date': 'تاریخ',
                'MRP': 'زیادہ سے زیادہ خوردہ قیمت',
                'Cost Price': 'لاگت قیمت',
                'Low Stock': 'کم اسٹاک',
                'In Stock': 'اسٹاک میں',
                'Out of Stock': 'اسٹاک ختم',
                'BQuantity': 'بلک مقدار',
                'Bonus Stock': 'بونس اسٹاک',
                'Trade Price': 'تجارتی قیمت',
                'Extra Discount': 'اضافی ڈسکاؤنٹ',
                'Effective Discount': 'مؤثر ڈسکاؤنٹ',
                'Per Pack': 'فی پیک',
                'Per Unit': 'فی یونٹ',
                'Per Tablet': 'فی گولی',
                'Profit Margin': 'منافع کا مارجن',
                'Stock Value': 'اسٹاک کی قیمت',
                'Expiring Soon': 'جلد میعاد ختم',
                'days': 'دن',
                'MRP per Pack Unit': 'MRP فی پیک یونٹ',
                'MRP per Base Unit': 'MRP فی بیس یونٹ',
                'Cost per Pack Unit': 'لاگت فی پیک یونٹ',
                'Cost per Base Unit': 'لاگت فی بیس یونٹ',
                'Sell per Item Unit': 'فروخت فی آئٹم یونٹ',
                'Sell per Base Unit': 'فروخت فی بیس یونٹ',
                'Bonus Buy': 'بونس خریدیں',
                'Bonus Free': 'بونس مفت',
                'Actual Stock': 'اصل اسٹاک',
                'Purchased Qty': 'خرید شدہ مقدار',
                'Pack Content': 'پیک مواد',
                'Supplier Name': 'سپلائر کا نام',
                'Cost Per Unit': 'فی یونٹ لاگت',
                'Sell Price Per Unit': 'فی یونٹ فروخت قیمت',
                'Sell Per Pack': 'فی پیک فروخت قیمت',
                'Cost Per Pack': 'فی پیک لاگت',
                'Stock Status': 'اسٹاک کی حیثیت',
                'to': 'تک',
                'per page': 'فی صفحہ',
                'Show': 'دکھائیں'
            },
            'ar': {
                'Products List': 'قائمة المنتجات',
                'All products details are below': 'جميع تفاصيل المنتجات أدناه',
                'Product Name': 'اسم المنتج',
                'Product Code': 'رمز المنتج',
                'Batch Number': 'رقم الدفعة',
                'Barcode': 'الباركود',
                'Category': 'الفئة',
                'Company': 'الشركة',
                'Supplier': 'المورد',
                'Packing Type': 'نوع التغليف',
                'Sub Packing Type': 'نوع التغليف الفرعي',
                'Items Per Pack': 'القطع لكل عبوة',
                'Unit': 'الوحدة',
                'Retail Price': 'سعر التجزئة',
                'Total Quantity': 'الكمية الإجمالية',
                'Quantity Alert': 'تنبيه الكمية المنخفضة',
                'Expiry Date': 'تاريخ الانتهاء',
                'Actions': 'الإجراءات',
                'Added By': 'أضيف بواسطة',
                'Search products...': 'بحث عن منتجات...',
                'Refresh': 'تحديث',
                'Export PDF': 'تصدير PDF',
                'Edit': 'تعديل',
                'Delete': 'حذف',
                'Close': 'إغلاق',
                'Save Changes': 'حفظ التغييرات',
                'Cancel': 'إلغاء',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Showing': 'عرض',
                'of': 'من',
                'Previous': 'السابق',
                'Next': 'التالي',
                'All': 'الكل',
                'Product Details': 'تفاصيل المنتج',
                'Switch Shop': 'تبديل المتجر',
                'No shop selected': 'لم يتم اختيار متجر',
                'Please select a shop to view products': 'الرجاء اختيار متجر لعرض المنتجات',
                'S.No': 'رقم',
                'Products': 'المنتجات',
                'Shop': 'متجر',
                'View': 'عرض',
                'Update Product': 'تحديث المنتج',
                'Updating...': 'جاري التحديث...',
                'Product updated successfully': 'تم تحديث المنتج بنجاح',
                'Error updating product': 'خطأ في تحديث المنتج',
                'Confirm Delete': 'تأكيد الحذف',
                'Yes, Delete': 'نعم، حذف',
                'No, Cancel': 'لا، إلغاء',
                'Portrait': 'عمودي',
                'Landscape': 'أفقي',
                'A4': 'A4',
                'Letter': 'رسالة',
                'Legal': 'قانوني',
                'A5': 'A5',
                'Product Report': 'تقرير المنتجات',
                'Product Directory': 'دليل المنتجات',
                'Total Products': 'إجمالي المنتجات',
                'Generated': 'تم الإنشاء',
                'Report ID': 'معرف التقرير',
                'Generated by': 'تم الإنشاء بواسطة',
                'Shop Code': 'رمز المتجر',
                'FILTERS APPLIED': 'المرشحات المطبقة',
                'Search': 'بحث',
                'From': 'من',
                'To': 'إلى',
                'Page': 'صفحة',
                'Date': 'التاريخ',
                'MRP': 'السعر الأقصى',
                'Cost Price': 'سعر التكلفة',
                'Low Stock': 'مخزون منخفض',
                'In Stock': 'في المخزون',
                'Out of Stock': 'نفد المخزون',
                'BQuantity': 'الكمية الإجمالية',
                'Bonus Stock': 'المخزون الإضافي',
                'Trade Price': 'سعر التجارة',
                'Extra Discount': 'خصم إضافي',
                'Effective Discount': 'الخصم الفعال',
                'Per Pack': 'لكل عبوة',
                'Per Unit': 'لكل وحدة',
                'Per Tablet': 'لكل قرص',
                'Profit Margin': 'هامش الربح',
                'Stock Value': 'قيمة المخزون',
                'Expiring Soon': 'ينتهي قريباً',
                'days': 'أيام',
                'MRP per Pack Unit': 'MRP لكل وحدة عبوة',
                'MRP per Base Unit': 'MRP لكل وحدة أساسية',
                'Cost per Pack Unit': 'التكلفة لكل وحدة عبوة',
                'Cost per Base Unit': 'التكلفة لكل وحدة أساسية',
                'Sell per Item Unit': 'البيع لكل وحدة عنصر',
                'Sell per Base Unit': 'البيع لكل وحدة أساسية',
                'Bonus Buy': 'مكافأة الشراء',
                'Bonus Free': 'مكافأة مجانية',
                'Actual Stock': 'المخزون الفعلي',
                'Purchased Qty': 'الكمية المشتراة',
                'Pack Content': 'محتوى العبوة',
                'Supplier Name': 'اسم المورد',
                'Cost Per Unit': 'التكلفة لكل وحدة',
                'Sell Price Per Unit': 'سعر البيع لكل وحدة',
                'Sell Per Pack': 'البيع لكل عبوة',
                'Cost Per Pack': 'التكلفة لكل عبوة',
                'Stock Status': 'حالة المخزون',
                'to': 'إلى',
                'per page': 'لكل صفحة',
                'Show': 'عرض'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) { }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) { }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        productList: 'Supplier-wise Purchases',
        formDetails: 'All products details are below',
        products: 'Products',
        shopName: 'Shop',
        noShopSelected: 'No shop selected. Please select a shop first.',
        switchShop: 'Switch Shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        current: 'Current',
        searchPlaceholder: 'Search Supplier',
        refresh: 'Refresh',
        loadingUserData: 'Loading your product data...',
        selectShop: 'Please select a shop to view products',
        productName: 'Product Name',
        productCode: 'Product Code',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        category: 'Category',
        company: 'Company',
        supplierName: 'Supplier',
        packingType: 'Packing Type',
        subPackingType: 'Sub Packing Type',
        itemsPerPack: 'Items Per Pack',
        unit: 'Unit',
        retailPrice: 'Retail Price',
        totalQuantity: 'Total Quantity',
        quantityAlert: 'Low Stock Alert',
        expiryDate: 'Expiry Date',
        actions: 'Actions',
        addedBy: 'Added By',
        serialNo: 'S.No',
        showing: 'Showing',
        of: 'of',
        previous: 'Previous',
        next: 'Next',
        all: 'All',
        productNameFilter: 'Product Name',
        productCodeFilter: 'Product Code',
        batchFilter: 'Batch Number',
        categoryFilter: 'Category',
        companyFilter: 'Company',
        dateRange: 'Date Range',
        addedByFilter: 'Added By',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportToPDF: 'Export PDF',
        orientation: 'Orientation',
        portrait: 'Portrait',
        landscape: 'Landscape',
        pageSize: 'Page Size',
        a4: 'A4',
        letter: 'Letter',
        legal: 'Legal',
        a5: 'A5',
        productDetails: 'Product Details',
        productInfo: 'Product Information',
        pricingInfo: 'Pricing Information',
        stockInfo: 'Stock Information',
        editProduct: 'Edit Product',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        confirmDelete: 'Confirm Delete',
        deleteMessage: 'Are you sure you want to delete this product?',
        deleteWarning: 'This action cannot be undone.',
        yesDelete: 'Yes, Delete',
        noCancel: 'No, Cancel',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        close: 'Close',
        productReport: 'Product Report',
        productDirectory: 'Product Directory',
        totalProducts: 'Total Products',
        generated: 'Generated',
        reportId: 'Report ID',
        generatedBy: 'Generated by',
        shopCode: 'Shop Code',
        filtersApplied: 'FILTERS APPLIED',
        search: 'Search',
        from: 'From',
        to: 'To',
        page: 'Page',
        date: 'Date',
        mrp: 'MRP',
        costPrice: 'Cost Price',
        lowStock: 'Low Stock',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        bquantity: 'BQuantity',
        bonusStock: 'Bonus Stock',
        tradePrice: 'Trade Price',
        extraDiscount: 'Extra Discount',
        effectiveDiscount: 'Effective Discount',
        perPack: 'Per Pack',
        perUnit: 'Per Unit',
        perTablet: 'Per Tablet',
        profitMargin: 'Profit Margin',
        stockValue: 'Stock Value',
        expiringSoon: 'Expiring Soon',
        days: 'days',
        mrpPerPackUnit: 'MRP per Pack Unit',
        mrpPerBaseUnit: 'MRP per Base Unit',
        costPerPackUnit: 'Cost per Pack Unit',
        costPerBaseUnit: 'Cost per Base Unit',
        sellPerItemUnit: 'Sell per Item Unit',
        sellPerBaseUnit: 'Sell per Base Unit',
        bonusBuy: 'Bonus Buy',
        bonusFree: 'Bonus Free',
        actualStock: 'Actual Stock',
        purchasedQty: 'Purchased Qty',
        packContent: 'Pack Content',
        costPerUnit: 'Cost Per Unit',
        sellPricePerUnit: 'Sell Price Per Unit',
        sellPerPack: 'Sell Per Pack',
        costPerPack: 'Cost Per Pack',
        stockStatus: 'Stock Status',
        show: 'Show',
        perPage: 'per page'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const productListTranslator = createSharedTranslator();

// ============================================
// HELPER FUNCTIONS
// ============================================

const getUnitDisplayLabel = (unitOfMeasure) => {
    const labels = {
        '1_liter': 'Liter', '1.5_liter': 'Liter', '2_liter': 'Liter',
        '3_liter': 'Liter', '5_liter': 'Liter',
        '200_ml': 'Milliliter', '250_ml': 'Milliliter', '300_ml': 'Milliliter',
        '350_ml': 'Milliliter', '400_ml': 'Milliliter', '450_ml': 'Milliliter',
        '500_ml': 'Milliliter',
        '0.5_liter': 'Liter', '0.7_liter': 'Liter', '1_liter_alt': 'Liter',
        '2_liter_alt': 'Liter', '3_liter_alt': 'Liter', '4_liter': 'Liter',
        '5_liter_alt': 'Liter', '6_liter': 'Liter', '7_liter': 'Liter',
        '10_liter': 'Liter', '20_liter': 'Liter', '60_liter': 'Liter',
        '208_liter': 'Liter', 'milliliter': 'Milliliter', 'kilogram': 'Kilogram',
        'gram': 'Gram', 'piece': 'Piece', 'dozen': 'Dozen', 'box': 'Box',
        'packet': 'Packet', 'can': 'Can', 'bottle': 'Bottle',
        'tablet': 'Tablet', 'capsule': 'Capsule', 'strip': 'Strip',
        'vial': 'Vial', 'ampoule': 'Ampoule', 'sachet': 'Sachet', 'tube': 'Tube'
    };
    return labels[unitOfMeasure] || 'Unit';
};

const getPluralUnitLabel = (label) => {
    const plurals = {
        'Liter': 'Liters', 'Milliliter': 'Milliliters', 'Kilogram': 'Kilograms',
        'Gram': 'Grams', 'Piece': 'Pieces', 'Dozen': 'Dozens', 'Box': 'Boxes',
        'Packet': 'Packets', 'Can': 'Cans', 'Bottle': 'Bottles',
        'Tablet': 'Tablets', 'Capsule': 'Capsules', 'Strip': 'Strips',
        'Vial': 'Vials', 'Ampoule': 'Ampoules', 'Sachet': 'Sachets',
        'Tube': 'Tubes', 'Unit': 'Units'
    };
    return plurals[label] || label + 's';
};

const calculateBQuantity = (itemsPerPack, unitOfMeasure, totalQuantity) => {
    if (itemsPerPack <= 0 || totalQuantity <= 0 || !unitOfMeasure) return '';
    const unitValue = 1;
    const totalItems = itemsPerPack * totalQuantity;
    const bulkValue = totalItems * unitValue;
    const unitLabel = getUnitDisplayLabel(unitOfMeasure);

    let formattedValue;
    if (Math.floor(bulkValue) === bulkValue) {
        formattedValue = bulkValue.toFixed(0);
    } else {
        formattedValue = bulkValue.toFixed(2);
    }
    const finalLabel = bulkValue !== 1 ? getPluralUnitLabel(unitLabel) : unitLabel;
    return `${formattedValue} ${finalLabel}`;
};

const getCategoryLabel = (category) => {
    const map = {
        'medicine': 'Medicine', 'surgical': 'Surgical', 'baby_care': 'Baby Care',
        'personal_care': 'Personal Care', 'veterinary': 'Veterinary', 'herbal': 'Herbal',
        'supplement': 'Supplement', 'medical_equipment': 'Medical Equipment',
        'diagnostic': 'Diagnostic', 'first_aid': 'First Aid', 'others': 'Others'
    };
    return map[category] || category || '-';
};

const getStockStatus = (quantity, alert) => {
    if (quantity <= 0) return { label: 'Out of Stock', color: '#ef4444', bg: '#ef444420' };
    if (quantity <= alert) return { label: 'Low Stock', color: '#f59e0b', bg: '#f59e0b20' };
    return { label: 'In Stock', color: '#22c55e', bg: '#22c55e20' };
};

const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    } catch { return dateString; }
};

const formatDateGlobal = (dateString) => {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    } catch { return dateString; }
};

const currentDateGlobal = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

const getExpiryStatus = (expiryDate) => {
    if (!expiryDate) return { label: 'No Expiry', color: '#6b7280', bg: '#6b728020' };
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDate);
    expiry.setHours(0, 0, 0, 0);
    const days = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
    if (days < 0) return { label: 'Expired', color: '#ef4444', bg: '#ef444420' };
    if (days <= 30) return { label: `${days} days left`, color: '#f59e0b', bg: '#f59e0b20' };
    return { label: `${days} days left`, color: '#22c55e', bg: '#22c55e20' };
};

const toMoney = (value) => {
    const num = parseFloat(value);
    return Number.isFinite(num) ? `Rs. ${num.toFixed(2)}` : '-';
};

const toNumberOrDash = (value, decimals = 0) => {
    const num = parseFloat(value);
    return Number.isFinite(num) && num !== 0 ? num.toFixed(decimals) : (Number.isFinite(num) ? num.toFixed(decimals) : '-');
};

const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '-';
    return `Rs. ${parseFloat(amount).toFixed(2)}`;
};

// ============================================
// DROPDOWN OPTIONS
// ============================================

const packingTypes = [
    { value: '', label: 'Select Packing Type' },
    { value: 'unit', label: 'Unit' },
    { value: 'box', label: 'Box' },
];

const subPackingTypesMap = {
    unit: [
        { value: 'tablet', label: 'Tablet' },
        { value: 'capsule', label: 'Capsule' },
        { value: 'softgel', label: 'Softgel Capsule' },
        { value: 'chewable_tablet', label: 'Chewable Tablet' },
        { value: 'dispersible_tablet', label: 'Dispersible Tablet' },
        { value: 'effervescent_tablet', label: 'Effervescent Tablet' },
        { value: 'sublingual_tablet', label: 'Sublingual Tablet' },
        { value: 'buccal_tablet', label: 'Buccal Tablet' },
        { value: 'vial', label: 'Vial' },
        { value: 'ampoule', label: 'Ampoule' },
        { value: 'prefilled_syringe', label: 'Prefilled Syringe' },
        { value: 'cartridge', label: 'Cartridge' },
        { value: 'tube', label: 'Tube' },
        { value: 'dropper_bottle', label: 'Dropper Bottle' },
        { value: 'bottle', label: 'Bottle' },
        { value: 'sachet', label: 'Sachet' },
        { value: 'strip', label: 'Strip' },
        { value: 'blister', label: 'Blister' },
        { value: 'respule', label: 'Respule' },
        { value: 'inhaler', label: 'Inhaler' },
        { value: 'patch', label: 'Patch' },
        { value: 'suppository', label: 'Suppository' },
        { value: 'pessary', label: 'Pessary' },
        { value: 'piece', label: 'Piece' },
        { value: 'eye_drops', label: 'Eye Drops' },
        { value: 'ear_drops', label: 'Ear Drops' },
        { value: 'nasal_spray', label: 'Nasal Spray' },
        { value: 'syrup', label: 'Syrup' },
        { value: 'suspension', label: 'Suspension' },
        { value: 'emulsion', label: 'Emulsion' },
        { value: 'elixir', label: 'Elixir' }
    ],
    box: [
        { value: 'box_1x1', label: '1 x 1 Tab Strip', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x2', label: '1 x 2 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x3', label: '1 x 3 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x4', label: '1 x 4 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x5', label: '1 x 5 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x6', label: '1 x 6 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x7', label: '1 x 7 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x8', label: '1 x 8 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x9', label: '1 x 9 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_1x10', label: '1 x 10 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_2x10', label: '2 x 10 Tab Strips', itemsPerPack: 2, unitOfMeasure: 'strip' },
        { value: 'box_3x10', label: '3 x 10 Tab Strips', itemsPerPack: 3, unitOfMeasure: 'strip' },
        { value: 'box_4x10', label: '4 x 10 Tab Strips', itemsPerPack: 4, unitOfMeasure: 'strip' },
        { value: 'box_5x10', label: '5 x 10 Tab Strips', itemsPerPack: 5, unitOfMeasure: 'strip' },
        { value: 'box_6x10', label: '6 x 10 Tab Strips', itemsPerPack: 6, unitOfMeasure: 'strip' },
        { value: 'box_7x10', label: '7 x 10 Tab Strips', itemsPerPack: 7, unitOfMeasure: 'strip' },
        { value: 'box_8x10', label: '8 x 10 Tab Strips', itemsPerPack: 8, unitOfMeasure: 'strip' },
        { value: 'box_9x10', label: '9 x 10 Tab Strips', itemsPerPack: 9, unitOfMeasure: 'strip' },
        { value: 'box_10x10', label: '10 x 10 Tab Strips', itemsPerPack: 10, unitOfMeasure: 'strip' },
        { value: 'box_1x20', label: '1 x 20 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_2x20', label: '2 x 20 Tab Strips', itemsPerPack: 2, unitOfMeasure: 'strip' },
        { value: 'box_3x20', label: '3 x 20 Tab Strips', itemsPerPack: 3, unitOfMeasure: 'strip' },
        { value: 'box_4x20', label: '4 x 20 Tab Strips', itemsPerPack: 4, unitOfMeasure: 'strip' },
        { value: 'box_5x20', label: '5 x 20 Tab Strips', itemsPerPack: 5, unitOfMeasure: 'strip' },
        { value: 'box_6x20', label: '6 x 20 Tab Strips', itemsPerPack: 6, unitOfMeasure: 'strip' },
        { value: 'box_7x20', label: '7 x 20 Tab Strips', itemsPerPack: 7, unitOfMeasure: 'strip' },
        { value: 'box_8x20', label: '8 x 20 Tab Strips', itemsPerPack: 8, unitOfMeasure: 'strip' },
        { value: 'box_9x20', label: '9 x 20 Tab Strips', itemsPerPack: 9, unitOfMeasure: 'strip' },
        { value: 'box_10x20', label: '10 x 20 Tab Strips', itemsPerPack: 10, unitOfMeasure: 'strip' },
        { value: 'box_1x30', label: '1 x 30 Tab Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_2x30', label: '2 x 30 Tab Strips', itemsPerPack: 2, unitOfMeasure: 'strip' },
        { value: 'box_3x30', label: '3 x 30 Tab Strips', itemsPerPack: 3, unitOfMeasure: 'strip' },
        { value: 'box_4x30', label: '4 x 30 Tab Strips', itemsPerPack: 4, unitOfMeasure: 'strip' },
        { value: 'box_5x30', label: '5 x 30 Tab Strips', itemsPerPack: 5, unitOfMeasure: 'strip' },
        { value: 'box_6x30', label: '6 x 30 Tab Strips', itemsPerPack: 6, unitOfMeasure: 'strip' },
        { value: 'box_7x30', label: '7 x 30 Tab Strips', itemsPerPack: 7, unitOfMeasure: 'strip' },
        { value: 'box_8x30', label: '8 x 30 Tab Strips', itemsPerPack: 8, unitOfMeasure: 'strip' },
        { value: 'box_9x30', label: '9 x 30 Tab Strips', itemsPerPack: 9, unitOfMeasure: 'strip' },
        { value: 'box_10x30', label: '10 x 30 Tab Strips', itemsPerPack: 10, unitOfMeasure: 'strip' },
        { value: 'box_500', label: '500 Tablets/Box', itemsPerPack: 500, unitOfMeasure: 'tablet' },
        { value: 'box_1000', label: '1000 Tablets/Box', itemsPerPack: 1000, unitOfMeasure: 'tablet' },
        { value: 'box_1x10_capsule', label: '1 x 10 Capsule Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_2x10_capsule', label: '2 x 10 Capsule Strips', itemsPerPack: 2, unitOfMeasure: 'strip' },
        { value: 'box_3x10_capsule', label: '3 x 10 Capsule Strips', itemsPerPack: 3, unitOfMeasure: 'strip' },
        { value: 'box_4x10_capsule', label: '4 x 10 Capsule Strips', itemsPerPack: 4, unitOfMeasure: 'strip' },
        { value: 'box_5x10_capsule', label: '5 x 10 Capsule Strips', itemsPerPack: 5, unitOfMeasure: 'strip' },
        { value: 'box_6x10_capsule', label: '6 x 10 Capsule Strips', itemsPerPack: 6, unitOfMeasure: 'strip' },
        { value: 'box_7x10_capsule', label: '7 x 10 Capsule Strips', itemsPerPack: 7, unitOfMeasure: 'strip' },
        { value: 'box_8x10_capsule', label: '8 x 10 Capsule Strips', itemsPerPack: 8, unitOfMeasure: 'strip' },
        { value: 'box_9x10_capsule', label: '9 x 10 Capsule Strips', itemsPerPack: 9, unitOfMeasure: 'strip' },
        { value: 'box_10x10_capsule', label: '10 x 10 Capsule Strips', itemsPerPack: 10, unitOfMeasure: 'strip' },
        { value: 'box_1x20_capsule', label: '1 x 20 Capsule Strips', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'box_2x20_capsule', label: '2 x 20 Capsule Strips', itemsPerPack: 2, unitOfMeasure: 'strip' },
        { value: 'box_3x20_capsule', label: '3 x 20 Capsule Strips', itemsPerPack: 3, unitOfMeasure: 'strip' },
        { value: 'box_4x20_capsule', label: '4 x 20 Capsule Strips', itemsPerPack: 4, unitOfMeasure: 'strip' },
        { value: 'box_5x20_capsule', label: '5 x 20 Capsule Strips', itemsPerPack: 5, unitOfMeasure: 'strip' },
        { value: 'box_6x20_capsule', label: '6 x 20 Capsule Strips', itemsPerPack: 6, unitOfMeasure: 'strip' },
        { value: 'box_7x20_capsule', label: '7 x 20 Capsule Strips', itemsPerPack: 7, unitOfMeasure: 'strip' },
        { value: 'box_8x20_capsule', label: '8 x 20 Capsule Strips', itemsPerPack: 8, unitOfMeasure: 'strip' },
        { value: 'box_9x20_capsule', label: '9 x 20 Capsule Strips', itemsPerPack: 9, unitOfMeasure: 'strip' },
        { value: 'box_10x20_capsule', label: '10 x 20 Capsule Strips', itemsPerPack: 10, unitOfMeasure: 'strip' },
        { value: 'box_500_capsule', label: '500 Capsules/Box', itemsPerPack: 500, unitOfMeasure: 'capsule' },
        { value: 'box_1000_capsule', label: '1000 Capsules/Box', itemsPerPack: 1000, unitOfMeasure: 'capsule' },
        { value: 'box_vial_1', label: '1 Vial/Box', itemsPerPack: 1, unitOfMeasure: 'vial' },
        { value: 'box_vial_2', label: '2 Vials/Box', itemsPerPack: 2, unitOfMeasure: 'vial' },
        { value: 'box_vial_3', label: '3 Vials/Box', itemsPerPack: 3, unitOfMeasure: 'vial' },
        { value: 'box_vial_4', label: '4 Vials/Box', itemsPerPack: 4, unitOfMeasure: 'vial' },
        { value: 'box_vial_5', label: '5 Vials/Box', itemsPerPack: 5, unitOfMeasure: 'vial' },
        { value: 'box_vial_6', label: '6 Vials/Box', itemsPerPack: 6, unitOfMeasure: 'vial' },
        { value: 'box_vial_7', label: '7 Vials/Box', itemsPerPack: 7, unitOfMeasure: 'vial' },
        { value: 'box_vial_8', label: '8 Vials/Box', itemsPerPack: 8, unitOfMeasure: 'vial' },
        { value: 'box_vial_9', label: '9 Vials/Box', itemsPerPack: 9, unitOfMeasure: 'vial' },
        { value: 'box_vial_10', label: '10 Vials/Box', itemsPerPack: 10, unitOfMeasure: 'vial' },
        { value: 'box_vial_12', label: '12 Vials/Box', itemsPerPack: 12, unitOfMeasure: 'vial' },
        { value: 'box_vial_15', label: '15 Vials/Box', itemsPerPack: 15, unitOfMeasure: 'vial' },
        { value: 'box_vial_20', label: '20 Vials/Box', itemsPerPack: 20, unitOfMeasure: 'vial' },
        { value: 'box_vial_24', label: '24 Vials/Box', itemsPerPack: 24, unitOfMeasure: 'vial' },
        { value: 'box_vial_25', label: '25 Vials/Box', itemsPerPack: 25, unitOfMeasure: 'vial' },
        { value: 'box_vial_30', label: '30 Vials/Box', itemsPerPack: 30, unitOfMeasure: 'vial' },
        { value: 'box_vial_50', label: '50 Vials/Box', itemsPerPack: 50, unitOfMeasure: 'vial' },
        { value: 'box_vial_100', label: '100 Vials/Box', itemsPerPack: 100, unitOfMeasure: 'vial' },
        { value: 'box_ampoule_1', label: '1 Ampoule/Box', itemsPerPack: 1, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_2', label: '2 Ampoules/Box', itemsPerPack: 2, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_3', label: '3 Ampoules/Box', itemsPerPack: 3, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_4', label: '4 Ampoules/Box', itemsPerPack: 4, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_5', label: '5 Ampoules/Box', itemsPerPack: 5, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_6', label: '6 Ampoules/Box', itemsPerPack: 6, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_7', label: '7 Ampoules/Box', itemsPerPack: 7, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_8', label: '8 Ampoules/Box', itemsPerPack: 8, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_9', label: '9 Ampoules/Box', itemsPerPack: 9, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_10', label: '10 Ampoules/Box', itemsPerPack: 10, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_12', label: '12 Ampoules/Box', itemsPerPack: 12, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_15', label: '15 Ampoules/Box', itemsPerPack: 15, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_20', label: '20 Ampoules/Box', itemsPerPack: 20, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_24', label: '24 Ampoules/Box', itemsPerPack: 24, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_25', label: '25 Ampoules/Box', itemsPerPack: 25, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_30', label: '30 Ampoules/Box', itemsPerPack: 30, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_50', label: '50 Ampoules/Box', itemsPerPack: 50, unitOfMeasure: 'ampoule' },
        { value: 'box_ampoule_100', label: '100 Ampoules/Box', itemsPerPack: 100, unitOfMeasure: 'ampoule' },
        { value: 'box_bottle_1', label: '1 Bottle/Box', itemsPerPack: 1, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_2', label: '2 Bottles/Box', itemsPerPack: 2, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_3', label: '3 Bottles/Box', itemsPerPack: 3, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_4', label: '4 Bottles/Box', itemsPerPack: 4, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_5', label: '5 Bottles/Box', itemsPerPack: 5, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_6', label: '6 Bottles/Box', itemsPerPack: 6, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_7', label: '7 Bottles/Box', itemsPerPack: 7, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_8', label: '8 Bottles/Box', itemsPerPack: 8, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_9', label: '9 Bottles/Box', itemsPerPack: 9, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_10', label: '10 Bottles/Box', itemsPerPack: 10, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_12', label: '12 Bottles/Box', itemsPerPack: 12, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_15', label: '15 Bottles/Box', itemsPerPack: 15, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_20', label: '20 Bottles/Box', itemsPerPack: 20, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_24', label: '24 Bottles/Box', itemsPerPack: 24, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_25', label: '25 Bottles/Box', itemsPerPack: 25, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_30', label: '30 Bottles/Box', itemsPerPack: 30, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_50', label: '50 Bottles/Box', itemsPerPack: 50, unitOfMeasure: 'bottle' },
        { value: 'box_bottle_100', label: '100 Bottles/Box', itemsPerPack: 100, unitOfMeasure: 'bottle' },
        { value: 'box_sachet_1', label: '1 Sachet/Box', itemsPerPack: 1, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_2', label: '2 Sachets/Box', itemsPerPack: 2, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_3', label: '3 Sachets/Box', itemsPerPack: 3, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_4', label: '4 Sachets/Box', itemsPerPack: 4, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_5', label: '5 Sachets/Box', itemsPerPack: 5, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_6', label: '6 Sachets/Box', itemsPerPack: 6, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_7', label: '7 Sachets/Box', itemsPerPack: 7, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_8', label: '8 Sachets/Box', itemsPerPack: 8, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_9', label: '9 Sachets/Box', itemsPerPack: 9, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_10', label: '10 Sachets/Box', itemsPerPack: 10, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_12', label: '12 Sachets/Box', itemsPerPack: 12, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_14', label: '14 Sachets/Box', itemsPerPack: 14, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_15', label: '15 Sachets/Box', itemsPerPack: 15, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_20', label: '20 Sachets/Box', itemsPerPack: 20, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_24', label: '24 Sachets/Box', itemsPerPack: 24, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_25', label: '25 Sachets/Box', itemsPerPack: 25, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_30', label: '30 Sachets/Box', itemsPerPack: 30, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_50', label: '50 Sachets/Box', itemsPerPack: 50, unitOfMeasure: 'sachet' },
        { value: 'box_sachet_100', label: '100 Sachets/Box', itemsPerPack: 100, unitOfMeasure: 'sachet' },
        { value: 'box_tube_1', label: '1 Tube/Box', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'box_tube_2', label: '2 Tubes/Box', itemsPerPack: 2, unitOfMeasure: 'tube' },
        { value: 'box_tube_3', label: '3 Tubes/Box', itemsPerPack: 3, unitOfMeasure: 'tube' },
        { value: 'box_tube_4', label: '4 Tubes/Box', itemsPerPack: 4, unitOfMeasure: 'tube' },
        { value: 'box_tube_5', label: '5 Tubes/Box', itemsPerPack: 5, unitOfMeasure: 'tube' },
        { value: 'box_tube_6', label: '6 Tubes/Box', itemsPerPack: 6, unitOfMeasure: 'tube' },
        { value: 'box_tube_7', label: '7 Tubes/Box', itemsPerPack: 7, unitOfMeasure: 'tube' },
        { value: 'box_tube_8', label: '8 Tubes/Box', itemsPerPack: 8, unitOfMeasure: 'tube' },
        { value: 'box_tube_9', label: '9 Tubes/Box', itemsPerPack: 9, unitOfMeasure: 'tube' },
        { value: 'box_tube_10', label: '10 Tubes/Box', itemsPerPack: 10, unitOfMeasure: 'tube' },
        { value: 'box_tube_12', label: '12 Tubes/Box', itemsPerPack: 12, unitOfMeasure: 'tube' },
        { value: 'box_tube_15', label: '15 Tubes/Box', itemsPerPack: 15, unitOfMeasure: 'tube' },
        { value: 'box_tube_20', label: '20 Tubes/Box', itemsPerPack: 20, unitOfMeasure: 'tube' },
        { value: 'box_tube_24', label: '24 Tubes/Box', itemsPerPack: 24, unitOfMeasure: 'tube' },
        { value: 'box_tube_25', label: '25 Tubes/Box', itemsPerPack: 25, unitOfMeasure: 'tube' },
        { value: 'box_tube_30', label: '30 Tubes/Box', itemsPerPack: 30, unitOfMeasure: 'tube' },
        { value: 'box_tube_50', label: '50 Tubes/Box', itemsPerPack: 50, unitOfMeasure: 'tube' },
        { value: 'box_tube_100', label: '100 Tubes/Box', itemsPerPack: 100, unitOfMeasure: 'tube' }
    ]
};

const unitsOfMeasure = [
    { value: '', label: 'Select Unit of Measure' },
    { value: 'tablet', label: 'Tablet' },
    { value: 'capsule', label: 'Capsule' },
    { value: 'strip', label: 'Strip' },
    { value: 'piece', label: 'Piece (pc)' },
    { value: 'bottle', label: 'Bottle' },
    { value: 'vial', label: 'Vial' },
    { value: 'ampoule', label: 'Ampoule' },
    { value: 'sachet', label: 'Sachet' },
    { value: 'tube', label: 'Tube' }
];

const categoryOptions = [
    { value: '', label: 'Select Category' },
    { value: 'medicine', label: 'Medicine' },
    { value: 'surgical', label: 'Surgical' },
    { value: 'baby_care', label: 'Baby Care' },
    { value: 'personal_care', label: 'Personal Care' },
    { value: 'veterinary', label: 'Veterinary' },
    { value: 'herbal', label: 'Herbal' },
    { value: 'supplement', label: 'Supplement' },
    { value: 'medical_equipment', label: 'Medical Equipment' },
    { value: 'diagnostic', label: 'Diagnostic' },
    { value: 'first_aid', label: 'First Aid' },
    { value: 'others', label: 'Others' }
];

// ============================================
// TOAST NOTIFICATION
// ============================================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ============================================
// SHOP SELECTOR MODAL
// ============================================
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozlistui-modal-overlay" onClick={onClose}>
            <div className="ozlistui-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozlistui-close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozlistui-modal-body">
                    {loading ? (
                        <div className="ozlistui-loading-shops">
                            <div className="ozlistui-loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="ozlistui-no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="ozlistui-shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`ozlistui-shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozlistui-active' : ''}`}
                                    onClick={() => onSelectShop(shop)}
                                >
                                    <div className="ozlistui-shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="ozlistui-shop-item-details">
                                        <div className="ozlistui-shop-item-name">{shop.shop_name}</div>
                                        <div className="ozlistui-shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="ozlistui-shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================
// CUSTOM DROPDOWN COMPONENT
// ============================================
const CustomDropdown = ({ label, icon, value, onChange, options, placeholder, translations, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [isHovering, setIsHovering] = useState(false);
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);
    const menuRef = useRef(null);
    const hoverTimeoutRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        if (!isHovering) {
            setSearchTerm(displayValue);
        }
    }, [displayValue, isHovering]);

    useEffect(() => {
        if (isOpen) {
            const event = new CustomEvent('dropdownOpened', { detail: { id: label } });
            window.dispatchEvent(event);
        }
    }, [isOpen, label]);

    useEffect(() => {
        const handleDropdownOpened = (event) => {
            if (event.detail && event.detail.id !== label) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        window.addEventListener('dropdownOpened', handleDropdownOpened);
        return () => window.removeEventListener('dropdownOpened', handleDropdownOpened);
    }, [label]);

    const filteredOptions = isHovering
        ? options
        : searchTerm.trim() === ''
            ? options
            : options.filter(opt =>
                opt.label.toLowerCase().includes(searchTerm.toLowerCase())
            );

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        setHighlightedIndex(-1);
        setIsHovering(false);
    };

    const handleKeyDown = (e) => {
        if (!isOpen) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(true);
                setHighlightedIndex(0);
                setIsHovering(false);
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setHighlightedIndex(prev =>
                    prev < filteredOptions.length - 1 ? prev + 1 : prev
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
                break;
            case 'Enter':
                e.preventDefault();
                if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
                    handleSelect(filteredOptions[highlightedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            case 'Tab':
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
                break;
            default:
                break;
        }
    };

    const handleMouseEnter = () => {
        if (disabled) return;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        hoverTimeoutRef.current = setTimeout(() => {
            setIsHovering(true);
            setIsOpen(true);
            setHighlightedIndex(0);
        }, 200);
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        setTimeout(() => {
            if (!isOpen) {
                setIsHovering(false);
            }
        }, 300);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
                setHighlightedIndex(-1);
                setIsHovering(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (highlightedIndex >= 0 && menuRef.current) {
            const items = menuRef.current.querySelectorAll('.ozlistui-custom-dropdown-option');
            if (items[highlightedIndex]) {
                items[highlightedIndex].scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex]);

    const handleInputClick = () => {
        if (disabled) return;
        setIsHovering(false);
        setSearchTerm(displayValue);
        setIsOpen(true);
        setHighlightedIndex(0);
    };

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setIsHovering(false);
        setSearchTerm(newValue);
        setIsOpen(true);
        setHighlightedIndex(0);
        if (!options.find(opt => opt.label.toLowerCase() === newValue.toLowerCase())) {
            onChange('');
        }
    };

    return (
        <div
            className="ozlistui-custom-dropdown-wrapper"
            ref={wrapperRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="ozlistui-custom-input-wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    onFocus={() => {
                        if (!disabled) {
                            setIsHovering(false);
                            setSearchTerm(displayValue);
                            setIsOpen(true);
                            setHighlightedIndex(0);
                        }
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="ozlistui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div className="ozlistui-custom-dropdown-menu" ref={menuRef}>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt, index) => (
                            <div
                                key={opt.value}
                                className={`ozlistui-custom-dropdown-option ${value === opt.value ? 'ozlistui-selected' : ''} ${highlightedIndex === index ? 'ozlistui-highlighted' : ''}`}
                                onClick={() => handleSelect(opt)}
                                onMouseEnter={() => setHighlightedIndex(index)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="ozlistui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// ============================================
// DETAIL ROW
// ============================================
const DetailRow = ({ label, value }) => (
    <div className="ozlistui-view-row">
        <span className="ozlistui-view-label">{label}:</span>
        <span className="ozlistui-view-value">{value === '' || value === null || value === undefined ? '-' : value}</span>
    </div>
);

// ============================================
// MAIN COMPONENT
// ============================================
const ElectronicsSupplierPurchases = () => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [fetchError, setFetchError] = useState('');

    // PDF Options
    const [pdfOrientation, setPdfOrientation] = useState('landscape');
    const [pdfPageSize, setPdfPageSize] = useState('a4');
    const [pdfPageRange, setPdfPageRange] = useState('all');
    const [pdfStartPage, setPdfStartPage] = useState(1);
    const [pdfEndPage, setPdfEndPage] = useState(1);

    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 950, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('wide');
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });

    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 650, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 950, label: 'Wide', icon: faPlus },
        full: { width: '95vw', label: 'Full Width', icon: faExpand },
        fullscreen: { width: '98vw', label: 'Full Screen', icon: faCompress }
    };

    // Theme, Dark Mode, Language State
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [currentTheme, setCurrentTheme] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [translations, setTranslations] = useState({});

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        progress: 100,
        timeLeft: 3
    });

    const toastTimerRef = useRef(null);
    const isMountedRef = useRef(true);

    // Edit form state
    const [editFormData, setEditFormData] = useState({
        product_name: '',
        product_code: '',
        batch_no: '',
        barcode: '',
        category: '',
        company: '',
        packing_type: '',
        sub_packing_type: '',
        items_per_pack: '',
        unit_of_measure: '',
        sell_per_pack: '',
        quantity: '',
        quantity_alert: '',
        expiry_date: '',
        date: '',
        mrp: '',
        trade_percent: '',
        extra_percent: '',
        bonus_buy: '',
        bonus_free: '',
        effective_cost_price: '',
        effective_discount_percent: '',
        mrp_per_pack_unit: '',
        mrp_per_base_unit: '',
        cost_price_per_pack_unit: '',
        cost_price_per_base_unit: '',
        pack_content_quantity: '',
        pack_content_label: '',
        pack_base_unit_label: '',
        sell_price_per_item_unit: '',
        sell_price_per_base_unit: '',
        bonus_stock_quantity: '',
        actual_stock_quantity: '',
        purchased_quantity: '',
        supplier_name: '',
        supplier_id: ''
    });
    const [editFormErrors, setEditFormErrors] = useState({});

    // Search state for dropdowns in edit modal
    const [editCategorySearchTerm, setEditCategorySearchTerm] = useState('');
    const [editPackingTypeSearchTerm, setEditPackingTypeSearchTerm] = useState('');
    const [editSubPackingSearchTerm, setEditSubPackingSearchTerm] = useState('');
    const [editUnitSearchTerm, setEditUnitSearchTerm] = useState('');
    const [editAvailableSubPackings, setEditAvailableSubPackings] = useState([]);

    // Dropdown visibility
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [showPackingTypeDropdown, setShowPackingTypeDropdown] = useState(false);
    const [showSubPackingDropdown, setShowSubPackingDropdown] = useState(false);
    const [showUnitDropdown, setShowUnitDropdown] = useState(false);

    // Refs for dropdowns
    const categoryDropdownRef = useRef(null);
    const packingTypeDropdownRef = useRef(null);
    const subPackingDropdownRef = useRef(null);
    const unitDropdownRef = useRef(null);

    // Business info state
    const [businessInfo, setBusinessInfo] = useState({
        businessname: '',
        bussinesslogo: '',
        businessaddress: '',
        fullname: '',
        email: ''
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);

    // Filter states
    const [filterBy, setFilterBy] = useState('');
    const [productNameFilter, setProductNameFilter] = useState('');
    const [productCodeFilter, setProductCodeFilter] = useState('');
    const [batchFilter, setBatchFilter] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [addedByFilter, setAddedByFilter] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [stockStatusFilter, setStockStatusFilter] = useState('');
    const [supplierFilter, setSupplierFilter] = useState('');
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierSearchTerm, setSupplierSearchTerm] = useState('');

    const escapeHtml = (text) => {
        if (!text) return '';
        return String(text).replace(/[&<>]/g, function (m) {
            if (m === '&') return '&amp;';
            if (m === '<') return '&lt;';
            if (m === '>') return '&gt;';
            return m;
        });
    };

    // Stock status options
    const stockStatusOptions = useMemo(() => [
        { value: '', label: 'All Status' },
        { value: 'in_stock', label: 'In Stock' },
        { value: 'low_stock', label: 'Low Stock' },
        { value: 'out_of_stock', label: 'Out of Stock' }
    ], []);

    const pdfOrientationOptions = useMemo(() => [
        { value: 'portrait', label: translations.portrait || 'Portrait' },
        { value: 'landscape', label: translations.landscape || 'Landscape' }
    ], [translations]);

    const pdfPageSizeOptions = useMemo(() => [
        { value: 'a4', label: translations.a4 || 'A4' },
        { value: 'letter', label: translations.letter || 'Letter' },
        { value: 'legal', label: translations.legal || 'Legal' },
        { value: 'a5', label: translations.a5 || 'A5' }
    ], [translations]);

    const filterByOptions = useMemo(() => [
        { value: '', label: translations.all || 'All' },
        { value: 'productName', label: translations.productNameFilter || 'Product Name' },
        { value: 'productCode', label: translations.productCodeFilter || 'Product Code' },
        { value: 'batch', label: translations.batchFilter || 'Batch Number' },
        { value: 'category', label: translations.categoryFilter || 'Category' },
        { value: 'company', label: translations.companyFilter || 'Company' },
        { value: 'supplier', label: 'Supplier' },
        { value: 'added_by', label: translations.addedByFilter || 'Added By' }
    ], [translations]);

    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100, timeLeft: 3 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ============================================
    // THEME SYNC
    // ============================================
    useEffect(() => {
        const applyTheme = (color) => {
            if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
            document.documentElement.style.setProperty('--ozlistui-primary', color);
            document.documentElement.style.setProperty('--ozlistui-primary-dark', color);
            document.documentElement.style.setProperty('--ozlistui-primary-light', color);
            setCurrentTheme(color);
        };

        applyTheme(currentTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentTheme) {
                applyTheme(storedTheme);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [currentTheme]);

    // ============================================
    // DARK MODE SYNC
    // ============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);

            const container = document.querySelector('.ozlistui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('ozlistui-dark');
                } else {
                    container.classList.remove('ozlistui-dark');
                }
            }

            if (isDark) {
                document.body.classList.add('ozlistui-dark');
                document.documentElement.classList.add('ozlistui-dark');
            } else {
                document.body.classList.remove('ozlistui-dark');
                document.documentElement.classList.remove('ozlistui-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.ozlistui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozlistui-dark');
                    } else {
                        container.classList.remove('ozlistui-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('ozlistui-dark');
                    document.documentElement.classList.add('ozlistui-dark');
                } else {
                    document.body.classList.remove('ozlistui-dark');
                    document.documentElement.classList.remove('ozlistui-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ============================================
    // AUTO-CALCULATION EFFECT
    // ============================================
    useEffect(() => {
        if (!showEditModal) return;

        const mrp = parseFloat(editFormData.mrp) || 0;
        const tradePercent = parseFloat(editFormData.trade_percent) || 0;
        const extraPercent = parseFloat(editFormData.extra_percent) || 0;
        const bonusBuy = parseInt(editFormData.bonus_buy) || 0;
        const bonusFree = parseInt(editFormData.bonus_free) || 0;
        const itemsPerPack = parseFloat(editFormData.items_per_pack) || 0;
        const unitOfMeasure = editFormData.unit_of_measure || '';
        const totalQuantity = parseFloat(editFormData.quantity) || 0;

        let effectiveCostPrice = 0;
        let discountPercent = 0;
        let mrpPerPackUnit = 0;
        let mrpPerBaseUnit = 0;
        let costPricePerPackUnit = 0;
        let costPricePerBaseUnit = 0;
        let sellPricePerItemUnit = 0;
        let sellPricePerBaseUnit = 0;
        let bonusStockQuantity = 0;
        let actualStockQuantity = totalQuantity;

        if (mrp > 0) {
            let price = mrp;
            const tp = tradePercent || 0;
            const extra = extraPercent || 0;
            const buy = bonusBuy || 0;
            const free = bonusFree || 0;

            if (tp > 0) {
                price = price * (1 - tp / 100);
            }
            if (extra > 0) {
                price = price * (1 - extra / 100);
            }

            let totalDiscount = 0;
            if (mrp > 0) {
                totalDiscount = ((mrp - price) / mrp) * 100;
            }

            effectiveCostPrice = price;
            discountPercent = totalDiscount;

            if (itemsPerPack > 0) {
                mrpPerPackUnit = mrp / itemsPerPack;
                costPricePerPackUnit = effectiveCostPrice / itemsPerPack;
                sellPricePerItemUnit = parseFloat(editFormData.sell_per_pack) / itemsPerPack || 0;
            }
        }

        if (bonusBuy > 0 && bonusFree > 0 && totalQuantity > 0) {
            const bonusSets = Math.floor(totalQuantity / bonusBuy);
            bonusStockQuantity = bonusSets * bonusFree;
            actualStockQuantity = totalQuantity + bonusStockQuantity;
        }

        const unitLabel = getUnitDisplayLabel(unitOfMeasure);
        const baseUnitLabel = unitLabel;

        setEditFormData(prev => ({
            ...prev,
            effective_cost_price: effectiveCostPrice > 0 ? effectiveCostPrice.toFixed(4) : '',
            effective_discount_percent: discountPercent > 0 ? discountPercent.toFixed(4) : '',
            mrp_per_pack_unit: mrpPerPackUnit > 0 ? mrpPerPackUnit.toFixed(4) : '',
            mrp_per_base_unit: mrpPerBaseUnit > 0 ? mrpPerBaseUnit.toFixed(4) : '',
            cost_price_per_pack_unit: costPricePerPackUnit > 0 ? costPricePerPackUnit.toFixed(4) : '',
            cost_price_per_base_unit: costPricePerBaseUnit > 0 ? costPricePerBaseUnit.toFixed(4) : '',
            sell_price_per_item_unit: sellPricePerItemUnit > 0 ? sellPricePerItemUnit.toFixed(4) : '',
            sell_price_per_base_unit: sellPricePerBaseUnit > 0 ? sellPricePerBaseUnit.toFixed(4) : '',
            bonus_stock_quantity: bonusStockQuantity > 0 ? bonusStockQuantity.toString() : '',
            actual_stock_quantity: actualStockQuantity > 0 ? actualStockQuantity.toString() : '',
            pack_content_quantity: itemsPerPack > 0 ? itemsPerPack.toString() : '',
            pack_content_label: itemsPerPack > 0 && unitLabel ? `${itemsPerPack} ${unitLabel}` : '',
            pack_base_unit_label: baseUnitLabel || ''
        }));
    }, [
        showEditModal,
        editFormData.mrp,
        editFormData.trade_percent,
        editFormData.extra_percent,
        editFormData.bonus_buy,
        editFormData.bonus_free,
        editFormData.items_per_pack,
        editFormData.unit_of_measure,
        editFormData.quantity,
        editFormData.sell_per_pack
    ]);

    // ============================================
    // UPDATE AVAILABLE SUB PACKINGS
    // ============================================
    useEffect(() => {
        if (editFormData.packing_type && subPackingTypesMap[editFormData.packing_type]) {
            setEditAvailableSubPackings(subPackingTypesMap[editFormData.packing_type]);
        } else {
            setEditAvailableSubPackings([]);
        }
    }, [editFormData.packing_type]);

    // ============================================
    // HANDLE EDIT SUB PACKING CHANGE
    // ============================================
    const handleEditSubPackingChange = (subPackingValue, subPackingLabel) => {
        const selectedSubPacking = editAvailableSubPackings.find(sp => sp.value === subPackingValue);
        if (selectedSubPacking) {
            let defaultItemsPerPack = selectedSubPacking.itemsPerPack || 1;
            let defaultUnitOfMeasure = selectedSubPacking.unitOfMeasure || 'piece';

            setEditFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: defaultItemsPerPack.toString(),
                unit_of_measure: defaultUnitOfMeasure
            }));
            setEditSubPackingSearchTerm(subPackingLabel);

            const selectedUnit = unitsOfMeasure.find(u => u.value === defaultUnitOfMeasure);
            if (selectedUnit) {
                setEditUnitSearchTerm(selectedUnit.label);
            }
        } else {
            setEditFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: '',
                unit_of_measure: ''
            }));
            setEditSubPackingSearchTerm(subPackingLabel);
        }
        setShowSubPackingDropdown(false);
    };

    // ============================================
    // FILTERED OPTIONS FOR EDIT DROPDOWNS
    // ============================================
    const filteredEditCategories = editCategorySearchTerm.trim() === ''
        ? categoryOptions
        : categoryOptions.filter(cat =>
            cat.label.toLowerCase().includes(editCategorySearchTerm.toLowerCase())
        );

    const filteredEditPackingTypes = editPackingTypeSearchTerm.trim() === ''
        ? packingTypes.filter(pt => pt.value !== '')
        : packingTypes.filter(pt =>
            pt.value !== '' && pt.label.toLowerCase().includes(editPackingTypeSearchTerm.toLowerCase())
        );

    const filteredEditSubPackings = editSubPackingSearchTerm.trim() === ''
        ? editAvailableSubPackings
        : editAvailableSubPackings.filter(sub =>
            sub.label.toLowerCase().includes(editSubPackingSearchTerm.toLowerCase())
        );

    const filteredEditUnits = editUnitSearchTerm.trim() === ''
        ? unitsOfMeasure.filter(u => u.value !== '')
        : unitsOfMeasure.filter(u =>
            u.value !== '' && u.label.toLowerCase().includes(editUnitSearchTerm.toLowerCase())
        );

    // ============================================
    // CLICK OUTSIDE HANDLERS FOR EDIT DROPDOWNS
    // ============================================
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
            if (packingTypeDropdownRef.current && !packingTypeDropdownRef.current.contains(event.target)) {
                setShowPackingTypeDropdown(false);
            }
            if (subPackingDropdownRef.current && !subPackingDropdownRef.current.contains(event.target)) {
                setShowSubPackingDropdown(false);
            }
            if (unitDropdownRef.current && !unitDropdownRef.current.contains(event.target)) {
                setShowUnitDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // ============================================
    // GET EDIT LABELS
    // ============================================
    const getEditPackingLabel = () => {
        const packingType = editFormData.packing_type;
        if (packingType) {
            const packingOption = packingTypes.find(p => p.value === packingType);
            return packingOption ? packingOption.label : packingType.charAt(0).toUpperCase() + packingType.slice(1);
        }
        return '';
    };

    const getEditUnitLabel = () => {
        return getUnitDisplayLabel(editFormData.unit_of_measure) || 'Unit';
    };

    const getEditBaseUnitLabel = () => {
        return editFormData.pack_base_unit_label || 'Unit';
    };

    const getEditPluralLabel = (label) => {
        const plurals = {
            'Liter': 'Liters', 'Milliliter': 'Milliliters', 'Kilogram': 'Kilograms',
            'Gram': 'Grams', 'Piece': 'Pieces', 'Dozen': 'Dozens', 'Box': 'Boxes',
            'Packet': 'Packets', 'Can': 'Cans', 'Bottle': 'Bottles',
            'Tablet': 'Tablets', 'Capsule': 'Capsules', 'Strip': 'Strips',
            'Vial': 'Vials', 'Ampoule': 'Ampoules', 'Sachet': 'Sachets',
            'Tube': 'Tubes', 'Unit': 'Units'
        };
        return plurals[label] || label + 's';
    };

    // ============================================
    // LANGUAGE SYNC
    // ============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await productListTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ============================================
    // RTL DIRECTION SYNC
    // ============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozlistui-container');

        if (container) {
            if (isRTL) {
                container.classList.add('ozlistui-rtl');
                container.classList.remove('ozlistui-ltr');
            } else {
                container.classList.add('ozlistui-ltr');
                container.classList.remove('ozlistui-rtl');
            }
        }

        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    // ============================================
    // MODAL FUNCTIONS
    // ============================================
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        if (mode === 'fullscreen') {
            modalRef.current.style.width = '98vw';
            modalRef.current.style.height = '90vh';
        } else {
            modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
            modalRef.current.style.height = 'auto';
        }
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .ozlistui-width-btn, .ozlistui-close-btn')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    useEffect(() => {
        if (showEditModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('wide'); setIsModalInitialized(true); }, 50);
        }
        if (!showEditModal) setIsModalInitialized(false);
    }, [showEditModal, centerModal, setWidthMode, isModalInitialized]);

    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showEditModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showEditModal]);

    // ============================================
    // FETCH SUPPLIERS
    // ============================================
    useEffect(() => {
        const fetchSuppliers = async () => {
            if (!currentShop || !currentShop.shop_id) return;
            try {
                const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_suppliers.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        action: 'search_suppliers',
                        shop_id: currentShop.shop_id
                    })
                });
                const data = await response.json();
                if (data.status === 'success' && data.data) {
                    const options = [
                        { value: '', label: 'All Suppliers' },
                        ...data.data.map(supplier => ({
                            value: supplier.supplier_name,
                            label: supplier.supplier_name,
                            supplier_id: supplier.supplierid
                        }))
                    ];
                    setSupplierOptions(options);
                }
            } catch (error) {
                console.error('Error fetching suppliers:', error);
            }
        };
        fetchSuppliers();
    }, [currentShop]);

    // ============================================
    // RESET FILTERS
    // ============================================
    const resetFilters = useCallback(() => {
        setFilterBy('');
        setProductNameFilter('');
        setProductCodeFilter('');
        setBatchFilter('');
        setCategoryFilter('');
        setCompanyFilter('');
        setAddedByFilter('');
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
        setStockStatusFilter('');
        setSupplierFilter('');
    }, []);

    // ============================================
    // FETCH PRODUCTS
    // ============================================
    const fetchProducts = useCallback(async () => {
        if (!user || !user.username) {
            if (isMountedRef.current) {
                showToast('error', 'User information not available');
                setLoading(false);
            }
            return;
        }
        if (!currentShop || !currentShop.shop_id) {
            if (isMountedRef.current) {
                showToast('error', translations.noShopSelected || 'Please select a shop first');
                setLoading(false);
            }
            return;
        }

        if (isMountedRef.current) {
            setLoading(true);
            setFetchError('');
        }

        const payload = {
            action: 'get_records',
            username: user.username,
            shop_id: currentShop.shop_id,
            limit: 10000,
            offset: 0,
            filters: {
                supplier: supplierFilter || undefined
            }
        };

        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_purchasessupplierwise.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const rawText = await response.text();
            let data;
            try {
                data = JSON.parse(rawText);
            } catch (parseErr) {
                console.error('[CosmeticsSupplierPurchases] Server did not return valid JSON. Raw response:', rawText.substring(0, 1000));
                throw new Error('Server returned an invalid response');
            }

            if (!response.ok) {
                console.warn('[CosmeticsSupplierPurchases] HTTP status', response.status, data);
            }

            if (!isMountedRef.current) return;

            if (data.status === 'success') {
                const rows = Array.isArray(data.data) ? data.data : [];
                setProducts(rows);
                if (rows.length === 0) {
                    console.info('[CosmeticsSupplierPurchases] Request succeeded but 0 rows returned for shop_id =', currentShop.shop_id);
                }
            } else {
                console.error('[CosmeticsSupplierPurchases] API returned error:', data.message, data);
                setFetchError(data.message || 'Failed to load products');
                showToast('error', data.message || translations.networkError || 'Failed to load products');
                setProducts([]);
            }
        } catch (error) {
            console.error('[CosmeticsSupplierPurchases] fetchProducts failed:', error);
            if (isMountedRef.current) {
                setFetchError(error.message || 'Network error occurred');
                showToast('error', error.message || translations.networkError || 'Network error occurred');
            }
        } finally {
            if (isMountedRef.current) setLoading(false);
        }
    }, [user, currentShop, translations, showToast, supplierFilter]);

    const fetchAvailableShops = useCallback(async () => {
        if (!user) return;
        setLoadingShops(true);
        try {
            const shopsData = await getShopsForSwitch();
            if (isMountedRef.current) setAvailableShops(shopsData.shops || []);
        } catch (error) {
            console.error('Error loading shops:', error);
            if (isMountedRef.current) setAvailableShops([]);
        } finally {
            if (isMountedRef.current) setLoadingShops(false);
        }
    }, [user, getShopsForSwitch]);

    const fetchBusinessInfo = useCallback(async () => {
        if (!user || !user.username) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/get_business_info.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_business_info', username: user.username })
            });
            const data = await response.json();
            if (isMountedRef.current) {
                if (data.status === 'success') {
                    setBusinessInfo({
                        businessname: data.businessname || '',
                        bussinesslogo: data.bussinesslogo || '',
                        businessaddress: data.businessaddress || '',
                        fullname: data.fullname || '',
                        email: data.email || ''
                    });
                } else {
                    setBusinessInfo({
                        businessname: user.business_name || '',
                        bussinesslogo: '',
                        businessaddress: '',
                        fullname: user.fullname || '',
                        email: user.email || ''
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching business info:', error);
            if (isMountedRef.current) {
                setBusinessInfo({
                    businessname: user.business_name || '',
                    bussinesslogo: '',
                    businessaddress: '',
                    fullname: user.fullname || '',
                    email: user.email || ''
                });
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && user.username && currentShop) {
            fetchProducts();
            fetchBusinessInfo();
            fetchAvailableShops();
        } else if (user && user.username && !currentShop) {
            setLoading(false);
        } else if (!user) {
            setLoading(false);
        }
    }, [user, currentShop?.shop_id, supplierFilter]);

    const handleSwitchShop = useCallback(async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                showToast('success', 'Shop switched successfully');
                setCurrentPage(1);
                resetFilters();
                setShowShopSelector(false);
            } else {
                showToast('error', 'Failed to switch shop');
            }
        } catch (error) {
            console.error('Error switching shop:', error);
            showToast('error', 'Failed to switch shop');
        }
    }, [switchShop, showToast, resetFilters]);

    // ============================================
    // APPLY FILTERS
    // ============================================
    const applyFilters = useCallback(() => {
        let filtered = [...products];

        // Search term filter (matches product name, batch, supplier, etc.)
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(product =>
                product.product_name?.toLowerCase().includes(term) ||
                product.product_code?.toLowerCase().includes(term) ||
                product.batch_no?.toLowerCase().includes(term) ||
                product.barcode?.toLowerCase().includes(term) ||
                product.company?.toLowerCase().includes(term) ||
                product.category?.toLowerCase().includes(term) ||
                product.supplier_name?.toLowerCase().includes(term) ||
                product.supplier?.toLowerCase().includes(term) ||
                product.username?.toLowerCase().includes(term)
            );
        }

        // Stock status filter
        if (stockStatusFilter) {
            filtered = filtered.filter(product => {
                const qty = parseFloat(product.quantity) || 0;
                const alert = parseFloat(product.quantity_alert) || 0;
                if (stockStatusFilter === 'in_stock') return qty > alert && qty > 0;
                if (stockStatusFilter === 'low_stock') return qty <= alert && qty > 0;
                if (stockStatusFilter === 'out_of_stock') return qty <= 0;
                return true;
            });
        }

        // Specific filters
        if (filterBy === 'productName' && productNameFilter.trim()) {
            const term = productNameFilter.toLowerCase();
            filtered = filtered.filter(product => product.product_name?.toLowerCase().includes(term));
        }
        if (filterBy === 'productCode' && productCodeFilter.trim()) {
            const term = productCodeFilter.toLowerCase();
            filtered = filtered.filter(product => product.product_code?.toLowerCase().includes(term));
        }
        if (filterBy === 'batch' && batchFilter.trim()) {
            const term = batchFilter.toLowerCase();
            filtered = filtered.filter(product => product.batch_no?.toLowerCase().includes(term));
        }
        if (filterBy === 'category' && categoryFilter.trim()) {
            const term = categoryFilter.toLowerCase();
            filtered = filtered.filter(product => product.category?.toLowerCase() === term);
        }
        if (filterBy === 'company' && companyFilter.trim()) {
            const term = companyFilter.toLowerCase();
            filtered = filtered.filter(product => product.company?.toLowerCase().includes(term));
        }
        if (filterBy === 'supplier' && supplierFilter.trim()) {
            const term = supplierFilter.toLowerCase();
            filtered = filtered.filter(product =>
                product.supplier_name?.toLowerCase().includes(term) ||
                product.supplier?.toLowerCase().includes(term)
            );
        }
        if (filterBy === 'added_by' && addedByFilter.trim()) {
            const term = addedByFilter.toLowerCase();
            filtered = filtered.filter(product => product.username?.toLowerCase().includes(term));
        }

        // Date range filter
        if (startDate) {
            const start = new Date(startDate);
            start.setHours(0, 0, 0, 0);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                productDate.setHours(0, 0, 0, 0);
                return productDate >= start;
            });
        }
        if (endDate) {
            const end = new Date(endDate);
            end.setHours(23, 59, 59, 999);
            filtered = filtered.filter(product => {
                if (!product.date) return false;
                const productDate = new Date(product.date);
                return productDate <= end;
            });
        }

        setFilteredProducts(filtered);
        setCurrentPage(1);
    }, [products, searchTerm, stockStatusFilter, filterBy, productNameFilter, productCodeFilter, batchFilter, categoryFilter, companyFilter, supplierFilter, addedByFilter, startDate, endDate]);

    useEffect(() => { applyFilters(); }, [applyFilters]);

    // ============================================
    // GET ROWS PER PAGE
    // ============================================
    const getRowsPerPage = useCallback(() => {
        if (pdfOrientation === 'landscape') return 18;
        return 12;
    }, [pdfOrientation]);

    // ============================================
    // PAGINATION
    // ============================================
    const pagination = useMemo(() => {
        const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentProducts = filteredProducts.slice(startIndex, endIndex);
        return { totalPages, startIndex, endIndex, currentProducts };
    }, [filteredProducts, currentPage, itemsPerPage]);

    // ============================================
    // CALCULATE TOTAL STOCK VALUE
    // ============================================
    const totalStockValue = filteredProducts
        .filter(product => {
            const quantity = parseFloat(product.quantity || 0);
            return quantity > 0;
        })
        .reduce((sum, product) => {
            const costPerUnit = parseFloat(
                product.cost_price_per_base_unit ||
                product.cost_per_unit ||
                0
            );
            const quantity = parseFloat(product.quantity || 0);
            return sum + (costPerUnit * quantity);
        }, 0);

    // ============================================
    // GET STOCK VALUE FOR PRODUCT
    // ============================================
    const getStockValueForProduct = useCallback((product) => {
        const costPerUnit = parseFloat(
            product.cost_price_per_base_unit ||
            product.cost_per_unit ||
            product.costPerUnit ||
            (product.cost_per_pack / (product.items_per_pack || 1)) ||
            0
        );
        const quantity = parseFloat(product.quantity || product.quantity || 0);
        return costPerUnit * quantity;
    }, []);

    // ============================================
    // PDF EXPORT - FIXED
    // ============================================
    const exportToPDF = useCallback(async () => {
        if (!filteredProducts || filteredProducts.length === 0) {
            showToast('warning', translations.noDataToExport || 'No data to export');
            return;
        }
        setPdfLoading(true);
        try {
            const currentLang = currentLanguage;
            const isRTL = currentLang === 'ur' || currentLang === 'ar';

            const pdfTextColor = '#1f2937';
            const pdfSubTextColor = '#6b7280';
            const pdfBorderColor = '#e5e7eb';
            const pdfHeaderBgColor = '#f9fafb';
            const pdfRowEvenBg = '#ffffff';
            const pdfRowOddBg = '#f9fafb';
            const pdfThemeColor = currentTheme;

            const pageSizeMap = { 'a4': 'a4', 'letter': 'letter', 'legal': 'legal', 'a5': 'a5' };
            const pageFormat = pageSizeMap[pdfPageSize] || 'a4';
            const pdf = new jsPDF({ orientation: pdfOrientation, unit: 'mm', format: pageFormat, compress: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const rowsPerPage = getRowsPerPage();

            let productsToExport = [...filteredProducts];

            if (pdfPageRange === 'range') {
                const totalPagesForRange = Math.ceil(productsToExport.length / rowsPerPage);
                const start = Math.max(1, pdfStartPage);
                const end = Math.min(totalPagesForRange, pdfEndPage);
                const startIdx = (start - 1) * rowsPerPage;
                const endIdx = Math.min(end * rowsPerPage, productsToExport.length);
                productsToExport = productsToExport.slice(startIdx, endIdx);
            }

            const totalPages = Math.ceil(productsToExport.length / rowsPerPage);

            const getPDFTranslation = (key, fallback = '') => {
                return translations[key] || fallback;
            };

            const renderPage = async (pageProducts, pageNum, startRowIndex) => {
                return new Promise((resolve, reject) => {
                    try {
                        const container = document.createElement('div');
                        container.style.width = '1200px';
                        container.style.padding = '12px 15px';
                        container.style.backgroundColor = '#ffffff';
                        container.style.color = pdfTextColor;
                        container.style.position = 'absolute';
                        container.style.left = '-9999px';
                        container.style.top = '0';
                        container.style.fontFamily = "'Segoe UI', 'Helvetica Neue', Arial, sans-serif";
                        container.style.direction = isRTL ? 'rtl' : 'ltr';
                        container.style.fontSize = '8px';

                        const productReportLabel = getPDFTranslation('productReport', 'Product Report');
                        const productDirectoryLabel = getPDFTranslation('productDirectory', 'Product Directory');
                        const totalProductsLabel = getPDFTranslation('totalProducts', 'Total Products');
                        const generatedLabel = getPDFTranslation('generated', 'Generated');
                        const reportIdLabel = getPDFTranslation('reportId', 'Report ID');
                        const generatedByLabel = getPDFTranslation('generatedBy', 'Generated by');
                        const shopCodeLabel = getPDFTranslation('shopCode', 'Shop Code');
                        const filtersAppliedLabel = getPDFTranslation('filtersApplied', 'FILTERS APPLIED');
                        const searchLabel = getPDFTranslation('search', 'Search');
                        const categoryLabel = getPDFTranslation('category', 'Category');
                        const fromLabel = getPDFTranslation('from', 'From');
                        const toLabel = getPDFTranslation('to', 'To');
                        const pageLabel = getPDFTranslation('page', 'Page');
                        const ofLabel = getPDFTranslation('of', 'of');
                        const stockStatusLabel = getPDFTranslation('stockStatus', 'Status');
                        const stockValueLabel = getPDFTranslation('stockValue', 'Stock Value');
                        const supplierLabel = getPDFTranslation('supplierName', 'Supplier');

                        const headerHTML = `
                            <div style="margin-bottom: 8px; text-align: center;">
                                <div style="font-size: 7px; letter-spacing: 2px; color: ${pdfSubTextColor}; margin-bottom: 3px; text-transform: uppercase; font-weight: 500;">${productReportLabel}</div>
                                <h1 style="color: ${pdfTextColor}; font-size: 16px; margin: 0 0 3px 0; font-weight: 600;">
                                    ${escapeHtml(currentShop?.shop_name) || escapeHtml(productDirectoryLabel)}
                                </h1>
                                <div style="width: 30px; height: 2px; background: ${pdfThemeColor}; margin: 4px auto;"></div>
                                ${businessInfo.businessname ? `<div style="color: ${pdfSubTextColor}; font-size: 8px; margin-top: 3px;">${escapeHtml(businessInfo.businessname)}</div>` : ''}
                                <div style="color: ${pdfSubTextColor}; font-size: 6px; margin-top: 3px;">
                                    ${totalProductsLabel}: ${productsToExport.length} | ${generatedLabel}: ${new Date().toLocaleString(currentLang)}
                                </div>
                            </div>
                            <div style="display: flex; justify-content: space-between; margin: 5px 0 6px 0; padding: 4px 0; border-top: 1px solid ${pdfBorderColor}; border-bottom: 1px solid ${pdfBorderColor}; ${isRTL ? 'flex-direction: row-reverse;' : ''}">
                                <div style="font-size: 5.5px; color: ${pdfSubTextColor};"><strong>${reportIdLabel}:</strong> #${currentDateGlobal().replace(/-/g, '')}-${String(pageNum).padStart(3, '0')}</div>
                                <div style="font-size: 5.5px; color: ${pdfSubTextColor};"><strong>${generatedByLabel}:</strong> ${escapeHtml(user?.fullname || user?.username || 'System')}</div>
                                <div style="font-size: 5.5px; color: ${pdfSubTextColor};"><strong>${shopCodeLabel}:</strong> ${escapeHtml(currentShop?.shop_code || 'N/A')}</div>
                            </div>
                        `;

                        const hasFilters = searchTerm || categoryFilter || startDate || endDate || supplierFilter;
                        const filterHTML = hasFilters ? `
                            <div style="margin: 4px 0; padding: 3px 8px; background: #f7f7f7; border-${isRTL ? 'right' : 'left'}: 3px solid ${pdfThemeColor}; font-size: 5.5px; color: ${pdfSubTextColor};">
                                <span style="font-weight: 600;">${filtersAppliedLabel}:</span> 
                                ${searchTerm ? `${searchLabel}: "${escapeHtml(searchTerm)}"` : ''}
                                ${categoryFilter ? ` | ${categoryLabel}: ${escapeHtml(categoryFilter)}` : ''}
                                ${supplierFilter ? ` | ${supplierLabel}: "${escapeHtml(supplierFilter)}"` : ''}
                                ${startDate ? ` | ${fromLabel}: ${startDate}` : ''}
                                ${endDate ? ` | ${toLabel}: ${endDate}` : ''}
                            </div>
                        ` : '';

                        // FIXED: Removed the duplicate stockValue column and fixed the calculation
                        let tableHTML = `
                            <table style="width: 100%; border-collapse: collapse; font-size: 5.5px; margin-top: 3px; table-layout: fixed;">
                                <thead>
                                    <tr style="background-color: ${pdfHeaderBgColor}; border-bottom: 2px solid ${pdfThemeColor}; height: 22px;">
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 2.5%; vertical-align: middle; height: 22px;">#</th>
                                        <th style="padding: 4px 2px; text-align: ${isRTL ? 'right' : 'left'}; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 8%; vertical-align: middle; height: 22px;">Name</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Batch</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Unit</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">MRP</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Retail</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">MRP/PU</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">MRP/BU</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Cost/PU</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Cost/BU</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">TP%</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">Extra%</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">Disc%</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 3%; vertical-align: middle; height: 22px;">Buy</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 3%; vertical-align: middle; height: 22px;">Free</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">Qty</th>
                                        <th style="padding: 4px 2px; text-align: right; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">Actual</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">BQty</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 4%; vertical-align: middle; height: 22px;">Alert</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Expiry</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; border-right: 1px solid ${pdfBorderColor}; width: 5%; vertical-align: middle; height: 22px;">Supplier</th>
                                        <th style="padding: 4px 2px; text-align: center; font-weight: 700; color: ${pdfTextColor}; width: 5%; vertical-align: middle; height: 22px;">Stock Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                        `;

                        pageProducts.forEach((product, idx) => {
                            const rowNum = startRowIndex + idx + 1;
                            const isEven = idx % 2 === 0;

                            const totalQty = parseFloat(product.quantity || 0);
                            const alertQty = parseFloat(product.quantity_alert || 0);

                            // FIXED: Properly calculate costPerUnit and stockValue
                            const costPerUnit = parseFloat(
                                product.cost_price_per_base_unit ||
                                product.cost_per_unit ||
                                0
                            );
                            const stockValue = costPerUnit * totalQty;

                            const bqty = calculateBQuantity(
                                parseFloat(product.items_per_pack) || 0,
                                product.unit_of_measure || '',
                                parseFloat(product.quantity || 0)
                            );

                            const stockStatus = getStockStatus(totalQty, alertQty);

                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${isEven ? pdfRowEvenBg : pdfRowOddBg}; height: 20px;">
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfSubTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${rowNum}</td>
                                    <td style="padding: 3px 2px; text-align: ${isRTL ? 'right' : 'left'}; color: ${pdfTextColor}; font-weight: 500; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px; word-wrap: break-word;">${escapeHtml(product.product_name) || '-'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${escapeHtml(product.batch_no) || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${getUnitDisplayLabel(product.unit_of_measure) || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.mrp ? `Rs.${Number(product.mrp).toFixed(2)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.sell_per_pack ? `Rs.${Number(product.sell_per_pack).toFixed(2)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.mrp_per_pack_unit ? `Rs.${Number(product.mrp_per_pack_unit).toFixed(4)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.mrp_per_base_unit ? `Rs.${Number(product.mrp_per_base_unit).toFixed(4)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.cost_price_per_pack_unit ? `Rs.${Number(product.cost_price_per_pack_unit).toFixed(4)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.cost_price_per_base_unit ? `Rs.${Number(product.cost_price_per_base_unit).toFixed(4)}` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.trade_percent ? `${Number(product.trade_percent).toFixed(2)}%` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.extra_percent ? `${Number(product.extra_percent).toFixed(2)}%` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.effective_discount_percent ? `${Number(product.effective_discount_percent).toFixed(2)}%` : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.bonus_buy || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.bonus_free || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${totalQty > 0 ? totalQty.toFixed(2) : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: right; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-family: monospace; vertical-align: middle; height: 20px;">${product.actual_stock_quantity ? Number(product.actual_stock_quantity).toFixed(2) : '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; font-size: 5px; vertical-align: middle; height: 20px;">${bqty || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${product.quantity_alert || '—'}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${formatDate(product.expiry_date)}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: ${pdfTextColor}; border-right: 0.5px solid ${pdfBorderColor}; vertical-align: middle; height: 20px;">${escapeHtml(product.supplier_name || product.supplier || '—')}</td>
                                    <td style="padding: 3px 2px; text-align: center; color: #8b5cf6; font-weight: bold; vertical-align: middle; height: 20px;">${formatCurrency(stockValue)}</td>
                                </tr>
                            `;
                        });

                        const emptyRowsNeeded = rowsPerPage - pageProducts.length;
                        for (let i = 0; i < emptyRowsNeeded; i++) {
                            tableHTML += `
                                <tr style="border-bottom: 0.5px solid ${pdfBorderColor}; background: ${(pageProducts.length + i) % 2 === 0 ? pdfRowEvenBg : pdfRowOddBg}; height: 20px;">
                                    <td style="padding: 3px 2px; text-align: center; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px; border-right: 0.5px solid ${pdfBorderColor};">&nbsp;</td>
                                    <td style="padding: 3px 2px;">&nbsp;</td>
                                </tr>
                            `;
                        }

                        tableHTML += `
                                </tbody>
                            </table>
                        `;

                        const footerHTML = `
                            <div style="margin-top: 6px; padding-top: 4px; text-align: center;">
                                <div style="width: 30px; height: 1px; background: ${pdfBorderColor}; margin: 0 auto 4px auto;"></div>
                                <div style="font-size: 5.5px; color: ${pdfSubTextColor};">${pageLabel} ${pageNum} ${ofLabel} ${totalPages}</div>
                            </div>
                        `;

                        container.innerHTML = headerHTML + filterHTML + tableHTML + footerHTML;
                        document.body.appendChild(container);
                        html2canvas(container, { scale: 2, backgroundColor: '#ffffff', logging: false }).then(canvas => {
                            document.body.removeChild(container);
                            resolve(canvas);
                        }).catch(err => { document.body.removeChild(container); reject(err); });
                    } catch (err) { reject(err); }
                });
            };

            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                const startRow = (pageNum - 1) * rowsPerPage;
                const endRow = Math.min(pageNum * rowsPerPage, productsToExport.length);
                const pageProducts = productsToExport.slice(startRow, endRow);
                const canvas = await renderPage(pageProducts, pageNum, startRow);
                if (pageNum > 1) {
                    pdf.addPage();
                }
                const imgWidth = pageWidth - 20;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 5, imgWidth, imgHeight);
            }

            const fileName = `Supplier_Purchases_${currentShop?.shop_name?.replace(/[^a-z0-9]/gi, '_') || 'Export'}_${currentDateGlobal()}.pdf`;
            pdf.save(fileName);
            showToast('success', `${translations.reportGenerated || 'Report generated!'} ${productsToExport.length} ${translations.products || 'products'} on ${totalPages} ${translations.pages || 'page(s)'}`);
        } catch (error) {
            console.error('PDF Error:', error);
            showToast('error', translations.pdfGenerationError || 'Error generating PDF');
        } finally {
            setPdfLoading(false);
        }
    }, [filteredProducts, currentLanguage, pdfOrientation, pdfPageSize, pdfPageRange, pdfStartPage, pdfEndPage, translations, businessInfo, currentShop, user, showToast, getRowsPerPage, searchTerm, categoryFilter, startDate, endDate, supplierFilter, currentTheme]);

    // ============================================
    // HANDLE ACTIONS
    // ============================================
    const handleView = useCallback((product) => { setSelectedProduct(product); setShowViewModal(true); }, []);

    const handleEdit = useCallback((product) => {
        if (product.username !== user?.username) {
            showToast('error', 'You can only edit your own product records');
            return;
        }
        setSelectedProduct(product);
        setEditFormData({
            product_name: product.product_name || '',
            product_code: product.product_code || '',
            batch_no: product.batch_no || '',
            barcode: product.barcode || '',
            category: product.category || '',
            company: product.company || '',
            packing_type: product.packing_type || '',
            sub_packing_type: product.sub_packing_type || '',
            items_per_pack: product.items_per_pack || '',
            unit_of_measure: product.unit_of_measure || '',
            sell_per_pack: product.sell_per_pack || '',
            quantity: product.quantity || '',
            quantity_alert: product.quantity_alert || '',
            expiry_date: product.expiry_date || '',
            date: product.date || '',
            mrp: product.mrp || '',
            trade_percent: product.trade_percent || '',
            extra_percent: product.extra_percent || '',
            bonus_buy: product.bonus_buy || '',
            bonus_free: product.bonus_free || '',
            effective_cost_price: product.effective_cost_price || '',
            effective_discount_percent: product.effective_discount_percent || '',
            mrp_per_pack_unit: product.mrp_per_pack_unit || '',
            mrp_per_base_unit: product.mrp_per_base_unit || '',
            cost_price_per_pack_unit: product.cost_price_per_pack_unit || '',
            cost_price_per_base_unit: product.cost_price_per_base_unit || '',
            pack_content_quantity: product.pack_content_quantity || '',
            pack_content_label: product.pack_content_label || '',
            pack_base_unit_label: product.pack_base_unit_label || '',
            sell_price_per_item_unit: product.sell_price_per_item_unit || '',
            sell_price_per_base_unit: product.sell_price_per_base_unit || '',
            bonus_stock_quantity: product.bonus_stock_quantity || '',
            actual_stock_quantity: product.actual_stock_quantity || '',
            purchased_quantity: product.purchased_quantity || '',
            supplier_name: product.supplier_name || '',
            supplier_id: product.supplier_id || ''
        });

        const categoryOption = categoryOptions.find(c => c.value === product.category);
        setEditCategorySearchTerm(categoryOption ? categoryOption.label : '');

        const packingOption = packingTypes.find(p => p.value === product.packing_type);
        setEditPackingTypeSearchTerm(packingOption ? packingOption.label : '');

        const subPackingOptions = product.packing_type ? (subPackingTypesMap[product.packing_type] || []) : [];
        const subOption = subPackingOptions.find(s => s.value === product.sub_packing_type);
        setEditSubPackingSearchTerm(subOption ? subOption.label : '');

        const unitOption = unitsOfMeasure.find(u => u.value === product.unit_of_measure);
        setEditUnitSearchTerm(unitOption ? unitOption.label : '');

        setEditFormErrors({});
        setShowEditModal(true);
    }, [user, showToast]);

    const handleDeleteClick = useCallback((productId) => {
        const product = products.find(p => p.id === productId);
        if (!product) return;
        if (product.username !== user?.username) {
            showToast('error', 'You can only delete products you added');
            return;
        }
        setProductToDelete(productId);
        setShowDeleteModal(true);
    }, [products, user, showToast]);

    const handleDelete = useCallback(async () => {
        if (!productToDelete || !currentShop) return;
        const product = products.find(p => p.id === productToDelete);
        if (!product || product.username !== user?.username) {
            showToast('error', 'You can only delete your own products');
            setShowDeleteModal(false);
            setProductToDelete(null);
            return;
        }
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_purchasessupplierwise.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'delete',
                    id: productToDelete,
                    username: user.username,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.deletedSuccess || 'Product deleted successfully');
                fetchProducts();
                setShowDeleteModal(false);
                setProductToDelete(null);
            } else {
                showToast('error', data.message || translations.deleteError || 'Error deleting product');
            }
        } catch (error) {
            console.error('Error deleting product:', error);
            showToast('error', translations.deleteError || 'Error deleting product');
        }
    }, [productToDelete, currentShop, products, user, translations, showToast, fetchProducts]);

    const handleUpdateProduct = useCallback(async (e) => {
        e.preventDefault();
        if (!selectedProduct || !currentShop) {
            showToast('error', 'Product or shop information missing');
            return;
        }
        if (selectedProduct.username !== user?.username) {
            showToast('error', 'You can only update your own product records');
            return;
        }

        const errors = {};
        if (!editFormData.product_name.trim()) errors.product_name = translations.productNameRequired || 'Product name is required';
        if (!editFormData.batch_no.trim()) errors.batch_no = translations.batchRequired || 'Batch number is required';
        if (!editFormData.items_per_pack || parseFloat(editFormData.items_per_pack) <= 0) errors.items_per_pack = 'Items per pack is required';
        if (!editFormData.unit_of_measure) errors.unit_of_measure = 'Unit of measure is required';
        if (!editFormData.sell_per_pack || parseFloat(editFormData.sell_per_pack) <= 0) errors.sell_per_pack = 'Retail price is required';
        if (!editFormData.quantity || parseFloat(editFormData.quantity) < 0) errors.quantity = 'Total quantity is required';
        if (!editFormData.quantity_alert || parseFloat(editFormData.quantity_alert) < 0) errors.quantity_alert = 'Low stock alert is required';
        if (Object.keys(errors).length > 0) { setEditFormErrors(errors); return; }
        setEditLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/cosmetics_module/cosmetics_purchasessupplierwise.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'edit',
                    id: selectedProduct.id,
                    username: user.username,
                    shop_id: currentShop.shop_id,
                    ...editFormData
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                showToast('success', translations.productUpdated || 'Product updated successfully');
                setShowEditModal(false);
                fetchProducts();
            } else {
                showToast('error', data.message || translations.updateError || 'Error updating product');
            }
        } catch (error) {
            console.error('Error updating product:', error);
            showToast('error', translations.updateError || 'Error updating product');
        } finally {
            setEditLoading(false);
        }
    }, [selectedProduct, currentShop, editFormData, user, translations, showToast, fetchProducts]);

    const handlePageChange = useCallback((page) => { if (page >= 1 && page <= pagination.totalPages) setCurrentPage(page); }, [pagination.totalPages]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // ============================================
    // RENDER HELPERS
    // ============================================

    const renderStickyHeader = () => (
        <div className="ozlistui-sticky-header">
            <div className="ozlistui-header-bg-animation">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
                <div className="gradient-orb orb-4"></div>
                <div className="gradient-orb orb-5"></div>
            </div>
            <div className="ozlistui-header-content">
                <div className="ozlistui-header-left">
                    <div className="ozlistui-header-title">
                        <h1>{translations.productList || 'Purchases by Supplier'}</h1>
                        <p>{translations.formDetails || 'All products details are below'}</p>
                    </div>
                </div>
                <div className="ozlistui-header-right">
                    {currentShop && (
                        <div className="ozlistui-header-search-wrapper">
                            <div className="ozlistui-floating-wrapper ozlistui-header-search">
                                <input
                                    type="text"
                                    id="headerSearch"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                    }}
                                    placeholder=" "
                                    className="ozlistui-header-search-input"
                                />
                                <label htmlFor="headerSearch">
                                    <FontAwesomeIcon icon={faSearch} />
                                    {translations.searchPlaceholder || 'Search products...'}
                                </label>
                            </div>
                        </div>
                    )}

                    <button
                        className="ozlistui-header-filter-btn"
                        onClick={() => setShowFilters(!showFilters)}
                        title={showFilters ? "Hide Filters" : "Show Filters"}
                    >
                        <FontAwesomeIcon icon={showFilters ? faEyeSlash : faFilter} />
                        <span>{showFilters ? "Hide Filters" : "Filters"}</span>
                    </button>

                    {!currentShop && (
                        <button className="ozlistui-header-shop-btn" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );

    const renderFiltersSection = () => (
        <div className="ozlistui-filters-section">
            <div className="ozlistui-filters-row">
                <CustomDropdown
                    label={translations.filterBy || 'Filter By'}
                    icon={faTag}
                    value={filterBy}
                    onChange={setFilterBy}
                    options={filterByOptions}
                    translations={translations}
                />

                {filterBy === 'productName' && (
                    <div className="ozlistui-filter-group">
                        <div className="ozlistui-floating-wrapper">
                            <input
                                type="text"
                                id="productNameFilter"
                                value={productNameFilter}
                                onChange={(e) => setProductNameFilter(e.target.value)}
                                placeholder=" "
                            />
                            <label htmlFor="productNameFilter">
                                <FontAwesomeIcon icon={faBox} />
                                {translations.productNameFilter || 'Product Name'}
                            </label>
                        </div>
                    </div>
                )}

                {filterBy === 'productCode' && (
                    <div className="ozlistui-filter-group">
                        <div className="ozlistui-floating-wrapper">
                            <input
                                type="text"
                                id="productCodeFilter"
                                value={productCodeFilter}
                                onChange={(e) => setProductCodeFilter(e.target.value)}
                                placeholder=" "
                            />
                            <label htmlFor="productCodeFilter">
                                <FontAwesomeIcon icon={faTag} />
                                {translations.productCodeFilter || 'Product Code'}
                            </label>
                        </div>
                    </div>
                )}

                {filterBy === 'batch' && (
                    <div className="ozlistui-filter-group">
                        <div className="ozlistui-floating-wrapper">
                            <input
                                type="text"
                                id="batchFilter"
                                value={batchFilter}
                                onChange={(e) => setBatchFilter(e.target.value)}
                                placeholder=" "
                            />
                            <label htmlFor="batchFilter">
                                <FontAwesomeIcon icon={faHashtag} />
                                {translations.batchFilter || 'Batch Number'}
                            </label>
                        </div>
                    </div>
                )}

                {filterBy === 'category' && (
                    <CustomDropdown
                        label={translations.categoryFilter || 'Category'}
                        icon={faLayerGroup}
                        value={categoryFilter}
                        onChange={setCategoryFilter}
                        options={categoryOptions}
                        translations={translations}
                    />
                )}

                {filterBy === 'company' && (
                    <div className="ozlistui-filter-group">
                        <div className="ozlistui-floating-wrapper">
                            <input
                                type="text"
                                id="companyFilter"
                                value={companyFilter}
                                onChange={(e) => setCompanyFilter(e.target.value)}
                                placeholder=" "
                            />
                            <label htmlFor="companyFilter">
                                <FontAwesomeIcon icon={faBuilding} />
                                {translations.companyFilter || 'Company'}
                            </label>
                        </div>
                    </div>
                )}

                {filterBy === 'supplier' && (
                    <CustomDropdown
                        label="Supplier"
                        icon={faTruck}
                        value={supplierFilter}
                        onChange={setSupplierFilter}
                        options={supplierOptions}
                        translations={translations}
                    />
                )}

                {filterBy === 'added_by' && (
                    <div className="ozlistui-filter-group">
                        <div className="ozlistui-floating-wrapper">
                            <input
                                type="text"
                                id="addedByFilter"
                                value={addedByFilter}
                                onChange={(e) => setAddedByFilter(e.target.value)}
                                placeholder=" "
                            />
                            <label htmlFor="addedByFilter">
                                <FontAwesomeIcon icon={faUser} />
                                {translations.addedByFilter || 'Added By'}
                            </label>
                        </div>
                    </div>
                )}

                <CustomDropdown
                    label="Stock Status"
                    icon={faExclamationCircle}
                    value={stockStatusFilter}
                    onChange={setStockStatusFilter}
                    options={stockStatusOptions}
                    translations={translations}
                />

                <CustomDropdown
                    label={translations.orientation || 'Orientation'}
                    icon={faFilePdf}
                    value={pdfOrientation}
                    onChange={setPdfOrientation}
                    options={pdfOrientationOptions}
                    translations={translations}
                />

                <CustomDropdown
                    label={translations.pageSize || 'Page Size'}
                    icon={faFilePdf}
                    value={pdfPageSize}
                    onChange={setPdfPageSize}
                    options={pdfPageSizeOptions}
                    translations={translations}
                />

                <div className="ozlistui-filter-group">
                    <button onClick={fetchProducts} className="ozlistui-refresh-btn" disabled={loading}>
                        <FontAwesomeIcon icon={faRefresh} spin={loading} />
                        <span className="ozlistui-btn-text">{translations.refresh || 'Refresh'}</span>
                    </button>
                </div>

                <div className="ozlistui-filter-group">
                    <button
                        onClick={exportToPDF}
                        className="ozlistui-refresh-btn"
                        disabled={filteredProducts.length === 0 || pdfLoading}
                        style={{ background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: 'white' }}
                    >
                        {pdfLoading ? <div className="ozlistui-btn-spinner-small"></div> : <FontAwesomeIcon icon={faFilePdf} />}
                        <span className="ozlistui-btn-text">{translations.exportToPDF || 'Export PDF'}</span>
                    </button>
                </div>
            </div>
        </div>
    );

    const renderSummaryCards = () => (
        <div className="ozlistui-summary-cards">
            <div className="ozlistui-summary-card">
                <div className="ozlistui-summary-icon" style={{ background: '#3b82f620', color: '#3b82f6' }}>
                    <FontAwesomeIcon icon={faBoxes} />
                </div>
                <div className="ozlistui-summary-info">
                    <h3>{filteredProducts.length}</h3>
                    <p>{translations.totalProducts || 'Total Products'}</p>
                </div>
            </div>
            <div className="ozlistui-summary-card">
                <div className="ozlistui-summary-icon" style={{ background: '#10b98120', color: '#10b981' }}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                </div>
                <div className="ozlistui-summary-info">
                    <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q > a; }).length}</h3>
                    <p>{translations.inStock || 'In Stock'}</p>
                </div>
            </div>
            <div className="ozlistui-summary-card">
                <div className="ozlistui-summary-icon" style={{ background: '#f59e0b20', color: '#f59e0b' }}>
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div className="ozlistui-summary-info">
                    <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); const a = parseFloat(p.quantity_alert || 0); return q <= a && q > 0; }).length}</h3>
                    <p>{translations.lowStock || 'Low Stock'}</p>
                </div>
            </div>
            <div className="ozlistui-summary-card">
                <div className="ozlistui-summary-icon" style={{ background: '#ef444420', color: '#ef4444' }}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
                <div className="ozlistui-summary-info">
                    <h3>{filteredProducts.filter(p => { const q = parseFloat(p.quantity || 0); return q <= 0; }).length}</h3>
                    <p>{translations.outOfStock || 'Out of Stock'}</p>
                </div>
            </div>
            <div className="ozlistui-summary-card">
                <div className="ozlistui-summary-icon" style={{ background: '#8b5cf620', color: '#8b5cf6' }}>
                    <FontAwesomeIcon icon={faCreditCard} />
                </div>
                <div className="ozlistui-summary-info">
                    <h3>{formatCurrency(totalStockValue)}</h3>
                    <p>{translations.stockValue || 'Stock Value'}</p>
                </div>
            </div>
        </div>
    );

    const renderTableHead = () => (
        <thead>
            <tr>
                <th className="ozlistui-id-column ozlistui-centered-cell" style={{ minWidth: '40px' }}>#</th>
                <th className="ozlistui-centered-cell" style={{ minWidth: '120px' }}>{translations.productName || 'Product Name'}</th>
                <th className="ozlistui-centered-cell" style={{ minWidth: '70px' }}>{translations.batchNumber || 'Batch'}</th>
                <th className="ozlistui-centered-cell" style={{ minWidth: '70px' }}>{translations.costPrice || 'Cost Price'}</th>
              
                <th className="ozlistui-centered-cell" style={{ minWidth: '50px' }}>{translations.totalQuantity || 'Qty'}</th>
                <th className="ozlistui-centered-cell" style={{ minWidth: '50px' }}>{translations.stockValue || 'Stock Value'}</th>
                
                <th className="ozlistui-centered-cell" style={{ minWidth: '70px' }}>{translations.supplierName || 'Supplier'}</th>
                <th className="ozlistui-actions-column ozlistui-centered-cell" style={{ minWidth: '120px' }}>{translations.actions || 'Actions'}</th>
            </tr>
        </thead>
    );

    const renderTableRow = (product, index) => {
        const addedBy = product.username || '-';
        const isSelfAdded = addedBy === user?.username;
        const stockStatus = getStockStatus(
            parseFloat(product.quantity) || 0,
            parseFloat(product.quantity_alert) || 0
        );
        const bqty = calculateBQuantity(
            parseFloat(product.items_per_pack) || 0,
            product.unit_of_measure || '',
            parseFloat(product.quantity) || 0
        );

        // Calculate stock value for this product
        const costPerUnit = parseFloat(
            product.cost_price_per_base_unit ||
            product.cost_per_unit ||
            0
        );
        const totalQty = parseFloat(product.quantity || 0);
        const stockValue = costPerUnit * totalQty;

        return (
            <tr key={product.id}>
                <td className="ozlistui-id-cell ozlistui-centered-cell">
                    <span className="ozlistui-cell-text">{pagination.startIndex + index + 1}</span>
                </td>
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text ozlistui-product-name">{product.product_name || 'Nil'}</span>
                </td>
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text">{product.batch_no || 'Nil'}</span>
                </td>
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text">{toMoney(product.cost_price_per_base_unit || product.cost_per_unit)}</span>
                </td>
               
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text">{product.quantity ? Number(product.quantity).toFixed(2) : 'Nil'}</span>
                </td>
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text" style={{ color: '#8b5cf6', fontWeight: 'bold' }}>
                        {formatCurrency(stockValue)}
                    </span>
                </td>
              
                <td className="ozlistui-centered-cell">
                    <span className="ozlistui-cell-text">{product.supplier_name || product.supplier || '-'}</span>
                </td>
                <td className="ozlistui-actions-cell ozlistui-centered-cell">
                    <div className="ozlistui-actions-content">
                        <button onClick={() => handleView(product)} className="ozlistui-action-btn ozlistui-view-btn" title={translations.view || 'View'}>
                            <FontAwesomeIcon icon={faEye} />
                        </button>
                        <button onClick={() => handleEdit(product)} className="ozlistui-action-btn ozlistui-edit-btn" title={translations.edit || 'Edit'}>
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button onClick={() => handleDeleteClick(product.id)} className="ozlistui-action-btn ozlistui-delete-btn" title={translations.delete || 'Delete'} disabled={!isSelfAdded} style={{ opacity: isSelfAdded ? 1 : 0.5, cursor: isSelfAdded ? 'pointer' : 'not-allowed' }}>
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                </td>
            </tr>
        );
    };

    const renderTable = () => (
        <div className="ozlistui-table-scroll">
            <div className="ozlistui-table-container">
                <div className="ozlistui-table-wrapper">
                    <table className="ozlistui-table">
                        {renderTableHead()}
                        <tbody>
                            {pagination.currentProducts.length === 0 ? (
                                <tr>
                                    <td colSpan={22} style={{ textAlign: 'center', padding: '2rem' }}>
                                        {fetchError
                                            ? `Error: ${fetchError}`
                                            : 'No products found for this shop yet.'}
                                    </td>
                                </tr>
                            ) : (
                                pagination.currentProducts.map((product, index) => renderTableRow(product, index))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

    const renderPaginationControls = () => {
        if (filteredProducts.length === 0 || !currentShop) return null;
        return (
            <div className="ozlistui-pagination">
                <div className="ozlistui-pagination-left">
                    <div className="ozlistui-per-page">
                        <span>{translations.show || 'Show'}</span>
                        <select
                            value={itemsPerPage}
                            onChange={(e) => {
                                setItemsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                            className="ozlistui-per-page-select"
                        >
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                        </select>
                        <span>{translations.perPage || 'per page'}</span>
                    </div>
                    <div className="ozlistui-pagination-info">
                        <span>
                            {translations.showing || 'Showing'}
                            <strong> {pagination.startIndex + 1} </strong>
                            {translations.to || 'to'}
                            <strong> {Math.min(pagination.startIndex + itemsPerPage, filteredProducts.length)} </strong>
                            {translations.of || 'of'}
                            <strong> {filteredProducts.length} </strong>
                            {translations.products || 'products'}
                        </span>
                    </div>
                </div>
                <div className="ozlistui-pagination-right">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="ozlistui-pagination-btn"
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                        <span>{translations.previous || 'Previous'}</span>
                    </button>
                    <div className="ozlistui-page-numbers">
                        {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                            let pageNum;
                            if (pagination.totalPages <= 5) {
                                pageNum = i + 1;
                            } else if (currentPage <= 3) {
                                pageNum = i + 1;
                            } else if (currentPage >= pagination.totalPages - 2) {
                                pageNum = pagination.totalPages - 4 + i;
                            } else {
                                pageNum = currentPage - 2 + i;
                            }
                            return (
                                <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`ozlistui-page-number ${currentPage === pageNum ? 'ozlistui-active' : ''}`}>
                                    {pageNum}
                                </button>
                            );
                        })}
                    </div>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === pagination.totalPages}
                        className="ozlistui-pagination-btn"
                    >
                        <span>{translations.next || 'Next'}</span>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            </div>
        );
    };

    // ============================================
    // VIEW MODAL
    // ============================================
    const renderViewModal = () => {
        if (!showViewModal || !selectedProduct) return null;
        const p = selectedProduct;
        const bqty = calculateBQuantity(
            parseFloat(p.items_per_pack) || 0,
            p.unit_of_measure || '',
            parseFloat(p.quantity) || 0
        );

        // Calculate stock value for view modal
        const costPerUnit = parseFloat(
            p.cost_price_per_base_unit ||
            p.cost_per_unit ||
            0
        );
        const totalQty = parseFloat(p.quantity || 0);
        const stockValue = costPerUnit * totalQty;

        return (
            <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-content ozlistui-view-modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-header">
                        <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faBox} /></div>
                        <div className="ozlistui-modal-title">
                            <h3>{translations.productDetails || 'Product Details'}</h3>
                            <span className="ozlistui-product-number-badge">#{p.id}</span>
                        </div>
                        <button className="ozlistui-close-btn" onClick={() => setShowViewModal(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <div className="ozlistui-modal-body ozlistui-view-modal-body">
                        <div className="ozlistui-view-section">
                            <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faBox} />{translations.productInfo || 'Product Information'}</h4>
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.productName || 'Product Name'} value={p.product_name} />
                                <DetailRow label={translations.batchNumber || 'Batch Number'} value={p.batch_no} />
                                <DetailRow label={translations.barcode || 'Barcode'} value={p.barcode} />
                                <DetailRow label={translations.category || 'Category'} value={getCategoryLabel(p.category)} />
                                <DetailRow label={translations.company || 'Company'} value={p.company} />
                                <DetailRow label={translations.packingType || 'Packing Type'} value={p.packing_type} />
                                <DetailRow label={translations.subPackingType || 'Sub Packing Type'} value={p.sub_packing_type} />
                                <DetailRow label={translations.itemsPerPack || 'Items Per Pack'} value={p.items_per_pack} />
                                <DetailRow label={translations.unit || 'Unit'} value={getUnitDisplayLabel(p.unit_of_measure)} />
                                <DetailRow label={translations.packContent || 'Pack Content'} value={p.pack_content_label} />
                                <DetailRow label={translations.supplierName || 'Supplier'} value={p.supplier_name || p.supplier || '-'} />
                            </div>
                        </div>

                        <div className="ozlistui-view-section">
                            <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faDollarSign} />{translations.pricingInfo || 'Pricing Information'}</h4>
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.mrp || 'MRP'} value={toMoney(p.mrp)} />
                                <DetailRow label={translations.retailPrice || 'Retail Price'} value={toMoney(p.sell_per_pack)} />
                                <DetailRow label={translations.mrpPerPackUnit || 'MRP per Pack Unit'} value={toMoney(p.mrp_per_pack_unit)} />
                                <DetailRow label={translations.mrpPerBaseUnit || 'MRP per Base Unit'} value={toMoney(p.mrp_per_base_unit)} />
                                <DetailRow label={translations.costPerPackUnit || 'Cost per Pack Unit'} value={toMoney(p.cost_price_per_pack_unit)} />
                                <DetailRow label={translations.costPerBaseUnit || 'Cost per Base Unit'} value={toMoney(p.cost_price_per_base_unit)} />
                                <DetailRow label={translations.sellPerItemUnit || 'Sell per Item Unit'} value={toMoney(p.sell_price_per_item_unit)} />
                                <DetailRow label={translations.sellPerBaseUnit || 'Sell per Base Unit'} value={toMoney(p.sell_price_per_base_unit)} />
                            </div>
                        </div>

                        <div className="ozlistui-view-section">
                            <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faPercent} />{translations.discounts || 'Discounts'}</h4>
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.tradePrice || 'Trade Price %'} value={p.trade_percent ? `${p.trade_percent}%` : '-'} />
                                <DetailRow label={translations.extraDiscount || 'Extra Discount %'} value={p.extra_percent ? `${p.extra_percent}%` : '-'} />
                                <DetailRow label={translations.effectiveDiscount || 'Effective Discount %'} value={p.effective_discount_percent ? `${p.effective_discount_percent}%` : '-'} />
                            </div>
                        </div>

                        <div className="ozlistui-view-section">
                            <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faGift} />{translations.bonusDetails || 'Bonus Details'}</h4>
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.bonusBuy || 'Bonus Buy'} value={p.bonus_buy || '-'} />
                                <DetailRow label={translations.bonusFree || 'Bonus Free'} value={p.bonus_free || '-'} />
                                <DetailRow label={translations.bonusStock || 'Bonus Stock'} value={p.bonus_stock_quantity || '0'} />
                            </div>
                        </div>

                        <div className="ozlistui-view-section">
                            <h4 className="ozlistui-view-section-title"><FontAwesomeIcon icon={faWarehouse} />{translations.stockInfo || 'Stock Information'}</h4>
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.purchasedQty || 'Purchased Quantity'} value={p.purchased_quantity || '0'} />
                                <DetailRow label={translations.totalQuantity || 'Total Quantity'} value={p.quantity || '0'} />
                                <DetailRow label={translations.actualStock || 'Actual Stock'} value={p.actual_stock_quantity || '0'} />
                                <DetailRow label={translations.bquantity || 'BQuantity'} value={bqty || '-'} />
                                <DetailRow label={translations.quantityAlert || 'Low Stock Alert'} value={p.quantity_alert || '0'} />
                                <DetailRow label={translations.expiryDate || 'Expiry Date'} value={formatDate(p.expiry_date)} />
                                <DetailRow label={translations.date || 'Date'} value={formatDate(p.date)} />
                                <DetailRow label={translations.stockValue || 'Stock Value'} value={formatCurrency(stockValue)} />
                            </div>
                        </div>

                        <div className="ozlistui-view-section ozlistui-metadata-section">
                            <div className="ozlistui-view-grid">
                                <DetailRow label={translations.addedBy || 'Added By'} value={<span className="ozlistui-added-by-badge">{p.username || '-'}</span>} />
                                {p.created_at && <DetailRow label="Created At" value={formatDate(p.created_at)} />}
                                {p.updated_at && <DetailRow label="Last Updated" value={formatDate(p.updated_at)} />}
                            </div>
                        </div>
                    </div>
                    <div className="ozlistui-modal-footer">
                        <button className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowViewModal(false)}>{translations.close || 'Close'}</button>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => { setShowViewModal(false); handleEdit(p); }}>
                            <FontAwesomeIcon icon={faEdit} />
                            {translations.edit || 'Edit'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ============================================
    // EDIT MODAL
    // ============================================
    const renderEditModal = () => {
        if (!showEditModal || !selectedProduct) return null;

        return (
            <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                <div
                    ref={modalRef}
                    className="ozlistui-modal-content ozlistui-edit-modal-content"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        position: 'fixed',
                        left: modalPosition.x || '50%',
                        top: modalPosition.y || '50%',
                        transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                        width: modalSize.width,
                        minWidth: '800px',
                        maxWidth: '120vw',
                        maxHeight: '90vh'
                    }}
                >
                    {/* Resize Handles */}
                    <div className="ozlistui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                    <div className="ozlistui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                    <div className="ozlistui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                    <div className="ozlistui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                    <div className="ozlistui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                    <div className="ozlistui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                    <div className="ozlistui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                    <div className="ozlistui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                    {/* Modal Header */}
                    <div className="ozlistui-modal-header" onMouseDown={startDrag}>
                        <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faEdit} /></div>
                        <div className="ozlistui-modal-title">
                            <h3>{translations.editProduct || 'Edit Product'}</h3>
                            <span className="ozlistui-product-number-badge">#{selectedProduct.id}</span>
                        </div>
                        <div className="ozlistui-width-control-group">
                            {Object.entries(widthModes).map(([key, mode]) => (
                                <button key={key} className={`ozlistui-width-btn ${currentWidthMode === key ? 'ozlistui-active' : ''}`} onClick={() => setWidthMode(key)} title={mode.label}>
                                    <FontAwesomeIcon icon={mode.icon} />
                                </button>
                            ))}
                        </div>
                        <button className="ozlistui-close-btn" onClick={() => setShowEditModal(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>

                    <form onSubmit={handleUpdateProduct}>
                        <div className="ozlistui-modal-body" style={{ padding: '15px', overflowY: 'auto', maxHeight: 'calc(90vh - 120px)' }}>

                            {/* SECTION 1: PRODUCT INFORMATION */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faBox} />
                                    {translations.productInfo || 'Product Information'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.product_name ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_product_name"
                                                name="product_name"
                                                value={editFormData.product_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, product_name: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.product_name ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_product_name">
                                                <FontAwesomeIcon icon={faBox} />
                                                {translations.productName || 'Product Name'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.product_name && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.product_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_product_code"
                                                name="product_code"
                                                value={editFormData.product_code}
                                                onChange={(e) => setEditFormData({ ...editFormData, product_code: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_product_code">
                                                <FontAwesomeIcon icon={faTag} />
                                                {translations.productCode || 'Product Code'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.batch_no ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_batch_no"
                                                name="batch_no"
                                                value={editFormData.batch_no}
                                                onChange={(e) => setEditFormData({ ...editFormData, batch_no: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.batch_no ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_batch_no">
                                                <FontAwesomeIcon icon={faHashtag} />
                                                {translations.batchNumber || 'Batch Number'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.batch_no && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.batch_no}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_barcode"
                                                name="barcode"
                                                value={editFormData.barcode}
                                                onChange={(e) => setEditFormData({ ...editFormData, barcode: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_barcode">
                                                <FontAwesomeIcon icon={faBarcode} />
                                                {translations.barcode || 'Barcode'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group" ref={categoryDropdownRef}>
                                        <div className="ozlistui-input-wrapper ozlistui-category-wrapper">
                                            <input
                                                type="text"
                                                id="edit_category"
                                                value={editCategorySearchTerm}
                                                onChange={(e) => {
                                                    setEditCategorySearchTerm(e.target.value);
                                                    setShowCategoryDropdown(true);
                                                    if (editFormData.category && !categoryOptions.find(c =>
                                                        c.label.toLowerCase() === e.target.value.toLowerCase()
                                                    )) {
                                                        setEditFormData(prev => ({ ...prev, category: '' }));
                                                    }
                                                }}
                                                onFocus={() => setShowCategoryDropdown(true)}
                                                placeholder=" "
                                                autoComplete="off"
                                            />
                                            <label htmlFor="edit_category">
                                                <FontAwesomeIcon icon={faLayerGroup} />
                                                {translations.category || 'Category'}
                                            </label>
                                            <FontAwesomeIcon icon={faChevronDown} className="ozlistui-dropdown-arrow" />
                                        </div>
                                        {showCategoryDropdown && (
                                            <div className="ozlistui-category-dropdown">
                                                {filteredEditCategories.length > 0 ? (
                                                    filteredEditCategories.map(cat => (
                                                        <div
                                                            key={cat.value}
                                                            className={`ozlistui-category-option ${editFormData.category === cat.value ? 'ozlistui-selected' : ''}`}
                                                            onClick={() => {
                                                                setEditFormData(prev => ({ ...prev, category: cat.value }));
                                                                setEditCategorySearchTerm(cat.label);
                                                                setShowCategoryDropdown(false);
                                                            }}
                                                        >
                                                            {cat.label}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="ozlistui-category-empty">No categories found</div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_company"
                                                name="company"
                                                value={editFormData.company}
                                                onChange={(e) => setEditFormData({ ...editFormData, company: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_company">
                                                <FontAwesomeIcon icon={faBuilding} />
                                                {translations.company || 'Company / Brand'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_supplier_name"
                                                name="supplier_name"
                                                value={editFormData.supplier_name}
                                                onChange={(e) => setEditFormData({ ...editFormData, supplier_name: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_supplier_name">
                                                <FontAwesomeIcon icon={faTruck} />
                                                {translations.supplierName || 'Supplier Name'}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 2: PACKING INFORMATION */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faBoxes} />
                                    {translations.packingInfo || 'Packing Information'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.packing_type ? 'ozlistui-has-error' : ''}`} ref={packingTypeDropdownRef}>
                                        <div className="ozlistui-input-wrapper ozlistui-category-wrapper">
                                            <input
                                                type="text"
                                                id="edit_packing_type"
                                                value={editPackingTypeSearchTerm}
                                                onChange={(e) => {
                                                    setEditPackingTypeSearchTerm(e.target.value);
                                                    setShowPackingTypeDropdown(true);
                                                    if (editFormData.packing_type && !packingTypes.find(p =>
                                                        p.label.toLowerCase() === e.target.value.toLowerCase()
                                                    )) {
                                                        setEditFormData(prev => ({ ...prev, packing_type: '', sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                                        setEditSubPackingSearchTerm('');
                                                        setEditUnitSearchTerm('');
                                                    }
                                                }}
                                                onFocus={() => setShowPackingTypeDropdown(true)}
                                                placeholder=" "
                                                autoComplete="off"
                                            />
                                            <label htmlFor="edit_packing_type">
                                                <FontAwesomeIcon icon={faBox} />
                                                {translations.packingType || 'Packing Type'} <span className="ozlistui-required">*</span>
                                            </label>
                                            <FontAwesomeIcon icon={faChevronDown} className="ozlistui-dropdown-arrow" />
                                        </div>
                                        {editFormErrors.packing_type && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.packing_type}
                                            </div>
                                        )}
                                        {showPackingTypeDropdown && (
                                            <div className="ozlistui-category-dropdown">
                                                {filteredEditPackingTypes.length > 0 ? (
                                                    filteredEditPackingTypes.map(pt => (
                                                        <div
                                                            key={pt.value}
                                                            className={`ozlistui-category-option ${editFormData.packing_type === pt.value ? 'ozlistui-selected' : ''}`}
                                                            onClick={() => {
                                                                setEditFormData(prev => ({ ...prev, packing_type: pt.value, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                                                setEditPackingTypeSearchTerm(pt.label);
                                                                setEditSubPackingSearchTerm('');
                                                                setEditUnitSearchTerm('');
                                                                setShowPackingTypeDropdown(false);
                                                            }}
                                                        >
                                                            {pt.label}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="ozlistui-category-empty">No packing types found</div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.sub_packing_type ? 'ozlistui-has-error' : ''}`} ref={subPackingDropdownRef}>
                                        <div className="ozlistui-input-wrapper ozlistui-category-wrapper">
                                            <input
                                                type="text"
                                                id="edit_sub_packing_type"
                                                value={editSubPackingSearchTerm}
                                                onChange={(e) => {
                                                    setEditSubPackingSearchTerm(e.target.value);
                                                    setShowSubPackingDropdown(true);
                                                    if (editFormData.sub_packing_type && !editAvailableSubPackings.find(s =>
                                                        s.label.toLowerCase() === e.target.value.toLowerCase()
                                                    )) {
                                                        setEditFormData(prev => ({ ...prev, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                                        setEditUnitSearchTerm('');
                                                    }
                                                }}
                                                onFocus={() => {
                                                    if (editFormData.packing_type) {
                                                        setShowSubPackingDropdown(true);
                                                    }
                                                }}
                                                placeholder=" "
                                                disabled={!editFormData.packing_type}
                                                autoComplete="off"
                                            />
                                            <label htmlFor="edit_sub_packing_type">
                                                <FontAwesomeIcon icon={faLayerGroup} />
                                                {translations.subPackingType || 'Sub Packing Type'} <span className="ozlistui-required">*</span>
                                            </label>
                                            <FontAwesomeIcon icon={faChevronDown} className="ozlistui-dropdown-arrow" />
                                        </div>
                                        {editFormErrors.sub_packing_type && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.sub_packing_type}
                                            </div>
                                        )}
                                        {showSubPackingDropdown && editFormData.packing_type && (
                                            <div className="ozlistui-category-dropdown">
                                                {filteredEditSubPackings.length > 0 ? (
                                                    filteredEditSubPackings.map(sub => (
                                                        <div
                                                            key={sub.value}
                                                            className={`ozlistui-category-option ${editFormData.sub_packing_type === sub.value ? 'ozlistui-selected' : ''}`}
                                                            onClick={() => handleEditSubPackingChange(sub.value, sub.label)}
                                                        >
                                                            {sub.label}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="ozlistui-category-empty">No sub packing types found</div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.items_per_pack ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_items_per_pack"
                                                name="items_per_pack"
                                                value={editFormData.items_per_pack}
                                                onChange={(e) => setEditFormData({ ...editFormData, items_per_pack: e.target.value })}
                                                step="1"
                                                min="0"
                                                placeholder=" "
                                                className={editFormErrors.items_per_pack ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_items_per_pack">
                                                <FontAwesomeIcon icon={faCalculator} />
                                                {translations.itemsPerPack || 'Items Per Pack'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.items_per_pack && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.items_per_pack}
                                            </div>
                                        )}
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.unit_of_measure ? 'ozlistui-has-error' : ''}`} ref={unitDropdownRef}>
                                        <div className="ozlistui-input-wrapper ozlistui-category-wrapper">
                                            <input
                                                type="text"
                                                id="edit_unit_of_measure"
                                                value={editUnitSearchTerm}
                                                onChange={(e) => {
                                                    setEditUnitSearchTerm(e.target.value);
                                                    setShowUnitDropdown(true);
                                                    if (editFormData.unit_of_measure && !unitsOfMeasure.find(u =>
                                                        u.label.toLowerCase() === e.target.value.toLowerCase()
                                                    )) {
                                                        setEditFormData(prev => ({ ...prev, unit_of_measure: '' }));
                                                    }
                                                }}
                                                onFocus={() => setShowUnitDropdown(true)}
                                                placeholder=" "
                                                autoComplete="off"
                                            />
                                            <label htmlFor="edit_unit_of_measure">
                                                <FontAwesomeIcon icon={faBalanceScale} />
                                                {translations.unitOfMeasure || 'Unit of Measure'} <span className="ozlistui-required">*</span>
                                            </label>
                                            <FontAwesomeIcon icon={faChevronDown} className="ozlistui-dropdown-arrow" />
                                        </div>
                                        {editFormErrors.unit_of_measure && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.unit_of_measure}
                                            </div>
                                        )}
                                        {showUnitDropdown && (
                                            <div className="ozlistui-category-dropdown">
                                                {filteredEditUnits.length > 0 ? (
                                                    filteredEditUnits.map(unit => (
                                                        <div
                                                            key={unit.value}
                                                            className={`ozlistui-category-option ${editFormData.unit_of_measure === unit.value ? 'ozlistui-selected' : ''}`}
                                                            onClick={() => {
                                                                setEditFormData(prev => ({ ...prev, unit_of_measure: unit.value }));
                                                                setEditUnitSearchTerm(unit.label);
                                                                setShowUnitDropdown(false);
                                                            }}
                                                        >
                                                            {unit.label}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="ozlistui-category-empty">No units found</div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_pack_content_label"
                                                name="pack_content_label"
                                                value={editFormData.pack_content_label}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_pack_content_label">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {translations.packContent || 'Pack Content'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 3: PRICING & MRP */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    {translations.pricingInfo || 'Pricing & MRP Information'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_mrp"
                                                name="mrp"
                                                value={editFormData.mrp}
                                                onChange={(e) => setEditFormData({ ...editFormData, mrp: e.target.value })}
                                                step="0.01"
                                                min="0"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_mrp">
                                                <FontAwesomeIcon icon={faDollarSign} />
                                                {translations.mrp || 'MRP (Max Retail Price)'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.sell_per_pack ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_sell_per_pack"
                                                name="sell_per_pack"
                                                value={editFormData.sell_per_pack}
                                                onChange={(e) => setEditFormData({ ...editFormData, sell_per_pack: e.target.value })}
                                                step="0.01"
                                                min="0"
                                                placeholder=" "
                                                className={editFormErrors.sell_per_pack ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_sell_per_pack">
                                                <FontAwesomeIcon icon={faDollarSign} />
                                                {translations.retailPrice || 'Retail Price Per Pack'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.sell_per_pack && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.sell_per_pack}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_mrp_per_pack_unit"
                                                name="mrp_per_pack_unit"
                                                value={editFormData.mrp_per_pack_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_mrp_per_pack_unit">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {`MRP per ${getEditUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_mrp_per_base_unit"
                                                name="mrp_per_base_unit"
                                                value={editFormData.mrp_per_base_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_mrp_per_base_unit">
                                                <FontAwesomeIcon icon={faPills} />
                                                {`MRP per ${getEditBaseUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 4: DISCOUNTS */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faPercent} />
                                    {translations.discounts || 'Discounts'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_trade_percent"
                                                name="trade_percent"
                                                value={editFormData.trade_percent}
                                                onChange={(e) => setEditFormData({ ...editFormData, trade_percent: e.target.value })}
                                                step="0.01"
                                                min="0"
                                                max="100"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_trade_percent">
                                                <FontAwesomeIcon icon={faPercent} />
                                                {translations.tradePrice || 'Trade Price %'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_extra_percent"
                                                name="extra_percent"
                                                value={editFormData.extra_percent}
                                                onChange={(e) => setEditFormData({ ...editFormData, extra_percent: e.target.value })}
                                                step="0.01"
                                                min="0"
                                                max="100"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_extra_percent">
                                                <FontAwesomeIcon icon={faPercent} />
                                                {translations.extraDiscount || 'Extra Discount %'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_effective_discount_percent"
                                                name="effective_discount_percent"
                                                value={editFormData.effective_discount_percent}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_effective_discount_percent">
                                                <FontAwesomeIcon icon={faPercent} />
                                                {translations.effectiveDiscount || 'Effective Discount %'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 5: COST PRICES */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faCoins} />
                                    {translations.costPrices || 'Cost Prices'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_effective_cost_price"
                                                name="effective_cost_price"
                                                value={editFormData.effective_cost_price}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_effective_cost_price">
                                                <FontAwesomeIcon icon={faDollarSign} />
                                                {translations.effectiveCostPrice || 'Effective Cost Price'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_cost_price_per_pack_unit"
                                                name="cost_price_per_pack_unit"
                                                value={editFormData.cost_price_per_pack_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_cost_price_per_pack_unit">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {`Cost per ${getEditUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_cost_price_per_base_unit"
                                                name="cost_price_per_base_unit"
                                                value={editFormData.cost_price_per_base_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_cost_price_per_base_unit">
                                                <FontAwesomeIcon icon={faPills} />
                                                {`Cost per ${getEditBaseUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 6: BONUS DETAILS */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faGift} />
                                    {translations.bonusDetails || 'Bonus Details'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_bonus_buy"
                                                name="bonus_buy"
                                                value={editFormData.bonus_buy}
                                                onChange={(e) => setEditFormData({ ...editFormData, bonus_buy: e.target.value })}
                                                step="1"
                                                min="0"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_bonus_buy">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {translations.bonusBuy || 'Bonus: Buy'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_bonus_free"
                                                name="bonus_free"
                                                value={editFormData.bonus_free}
                                                onChange={(e) => setEditFormData({ ...editFormData, bonus_free: e.target.value })}
                                                step="1"
                                                min="0"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_bonus_free">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {translations.bonusFree || 'Bonus: Free'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_bonus_stock_quantity"
                                                name="bonus_stock_quantity"
                                                value={editFormData.bonus_stock_quantity}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly"
                                            />
                                            <label htmlFor="edit_bonus_stock_quantity">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {translations.bonusStock || 'Bonus Stock Quantity'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 7: STOCK INFORMATION */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faWarehouse} />
                                    {translations.stockInfo || 'Stock Information'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className={`ozlistui-form-group ${editFormErrors.quantity ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_quantity"
                                                name="quantity"
                                                value={editFormData.quantity}
                                                onChange={(e) => setEditFormData({ ...editFormData, quantity: e.target.value })}
                                                step="0.001"
                                                min="0"
                                                placeholder=" "
                                                className={editFormErrors.quantity ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_quantity">
                                                <FontAwesomeIcon icon={faWarehouse} />
                                                {translations.totalQuantity || 'Total Quantity'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.quantity && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.quantity}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_purchased_quantity"
                                                name="purchased_quantity"
                                                value={editFormData.purchased_quantity}
                                                onChange={(e) => setEditFormData({ ...editFormData, purchased_quantity: e.target.value })}
                                                step="0.001"
                                                min="0"
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_purchased_quantity">
                                                <FontAwesomeIcon icon={faWarehouse} />
                                                {translations.purchasedQty || 'Purchased Quantity'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_actual_stock_quantity"
                                                name="actual_stock_quantity"
                                                value={editFormData.actual_stock_quantity}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly"
                                            />
                                            <label htmlFor="edit_actual_stock_quantity">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {translations.actualStock || 'Actual Stock Quantity'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.quantity_alert ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="number"
                                                id="edit_quantity_alert"
                                                name="quantity_alert"
                                                value={editFormData.quantity_alert}
                                                onChange={(e) => setEditFormData({ ...editFormData, quantity_alert: e.target.value })}
                                                step="0.001"
                                                min="0"
                                                placeholder=" "
                                                className={editFormErrors.quantity_alert ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_quantity_alert">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {translations.quantityAlert || 'Low Stock Alert'} <span className="ozlistui-required">*</span>
                                            </label>
                                        </div>
                                        {editFormErrors.quantity_alert && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.quantity_alert}
                                            </div>
                                        )}
                                    </div>

                                    <div className="ozlistui-form-group ozlistui-full-width">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_bquantity"
                                                name="bquantity"
                                                value={calculateBQuantity(
                                                    parseFloat(editFormData.items_per_pack) || 0,
                                                    editFormData.unit_of_measure || '',
                                                    parseFloat(editFormData.actual_stock_quantity) || parseFloat(editFormData.quantity) || 0
                                                )}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly"
                                            />
                                            <label htmlFor="edit_bquantity">
                                                <FontAwesomeIcon icon={faCubes} />
                                                {translations.bquantity || 'BQuantity (Bulk Quantity)'} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 8: DATES */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {translations.dates || 'Dates'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_date"
                                                name="date"
                                                value={editFormData.date}
                                                onChange={(e) => setEditFormData({ ...editFormData, date: e.target.value })}
                                                placeholder=" "
                                            />
                                            <label htmlFor="edit_date">
                                                <FontAwesomeIcon icon={faCalendar} />
                                                {translations.date || 'Date'}
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`ozlistui-form-group ${editFormErrors.expiry_date ? 'ozlistui-has-error' : ''}`}>
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="date"
                                                id="edit_expiry_date"
                                                name="expiry_date"
                                                value={editFormData.expiry_date}
                                                onChange={(e) => setEditFormData({ ...editFormData, expiry_date: e.target.value })}
                                                placeholder=" "
                                                className={editFormErrors.expiry_date ? 'ozlistui-error' : ''}
                                            />
                                            <label htmlFor="edit_expiry_date">
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                                {translations.expiryDate || 'Expiry Date'}
                                            </label>
                                        </div>
                                        {editFormErrors.expiry_date && (
                                            <div className="ozlistui-error-message">
                                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                                {editFormErrors.expiry_date}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* SECTION 9: SELL PRICES PER UNIT */}
                            <div className="ozlistui-edit-section">
                                <h4 className="ozlistui-edit-section-title">
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    {translations.sellPrices || 'Sell Prices Per Unit'}
                                </h4>
                                <div className="ozlistui-form-grid">
                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_sell_price_per_item_unit"
                                                name="sell_price_per_item_unit"
                                                value={editFormData.sell_price_per_item_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_sell_price_per_item_unit">
                                                <FontAwesomeIcon icon={faBoxes} />
                                                {`Sell per ${getEditUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="ozlistui-form-group">
                                        <div className="ozlistui-input-wrapper">
                                            <input
                                                type="text"
                                                id="edit_sell_price_per_base_unit"
                                                name="sell_price_per_base_unit"
                                                value={editFormData.sell_price_per_base_unit}
                                                readOnly
                                                placeholder=" "
                                                className="ozlistui-readonly ozlistui-per-unit-price"
                                            />
                                            <label htmlFor="edit_sell_price_per_base_unit">
                                                <FontAwesomeIcon icon={faPills} />
                                                {`Sell per ${getEditBaseUnitLabel()}`} <span className="ozlistui-auto">(Auto)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Modal Footer */}
                        <div className="ozlistui-modal-footer">
                            <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowEditModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                                {translations.cancel || 'Cancel'}
                            </button>
                            <button type="submit" className="ozlistui-btn ozlistui-btn-primary" disabled={editLoading}>
                                {editLoading ? (
                                    <>
                                        <div className="ozlistui-btn-spinner"></div>
                                        <span>{translations.updating || 'Updating...'}</span>
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faSave} />
                                        <span>{translations.saveChanges || 'Save Changes'}</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    // ============================================
    // DELETE MODAL
    // ============================================
    const renderDeleteModal = () => {
        if (!showDeleteModal) return null;
        return (
            <div className="ozlistui-modal-overlay" onClick={(e) => e.stopPropagation()}>
                <div className="ozlistui-modal-content ozlistui-delete-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="ozlistui-modal-header ozlistui-delete-header">
                        <div className="ozlistui-modal-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                        <div className="ozlistui-modal-title"><h3>{translations.confirmDelete || 'Confirm Delete'}</h3></div>
                        <button className="ozlistui-close-btn" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                    <div className="ozlistui-modal-body">
                        <div className="ozlistui-delete-message">
                            <p>{translations.deleteMessage || 'Are you sure you want to delete this product?'}</p>
                            <p><FontAwesomeIcon icon={faExclamationTriangle} /> {translations.deleteWarning || 'This action cannot be undone.'}</p>
                        </div>
                    </div>
                    <div className="ozlistui-modal-footer">
                        <button type="button" className="ozlistui-btn ozlistui-btn-secondary" onClick={() => setShowDeleteModal(false)}><FontAwesomeIcon icon={faTimes} />{translations.noCancel || 'No, Cancel'}</button>
                        <button type="button" className="ozlistui-btn ozlistui-btn-delete" onClick={handleDelete}><FontAwesomeIcon icon={faTrash} />{translations.yesDelete || 'Yes, Delete'}</button>
                    </div>
                </div>
            </div>
        );
    };

    // ============================================
    // MAIN RENDER
    // ============================================
    return (
        <div className={`ozlistui-container ${isRTL ? 'ozlistui-rtl' : 'ozlistui-ltr'} ${darkMode ? 'ozlistui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            {renderStickyHeader()}
            {showFilters && renderFiltersSection()}

            {loading ? (
                <div className="ozlistui-loading-container">
                    <div className="ozlistui-loading-spinner"></div>
                    <p>{translations.loadingUserData || 'Loading your product data...'}</p>
                </div>
            ) : !currentShop ? (
                <div className="ozlistui-no-shop-container">
                    <div className="ozlistui-no-shop-message">
                        <FontAwesomeIcon icon={faStore} />
                        <h3>{translations.noShopSelected || 'No Shop Selected'}</h3>
                        <p>{translations.selectShop || 'Please select a shop to view products'}</p>
                        <button className="ozlistui-btn ozlistui-btn-primary" onClick={() => setShowShopSelector(true)}>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span>{translations.switchShop || 'Switch Shop'}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    {renderSummaryCards()}
                    {renderTable()}
                    {renderPaginationControls()}
                </>
            )}

            {renderViewModal()}
            {renderEditModal()}
            {renderDeleteModal()}
        </div>
    );
};

export default ElectronicsSupplierPurchases;